<template>
  <v-container
    v-if="order"
  >
    <validation-observer
      ref="acceptCollectionFormValidator"
    >
      <v-card flat>

        <!-- 更新履歴 -->
        <v-card-title v-if="editOrderId">
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn
                rounded
                color="white"
                @click="showUpdateHistoriesButtonClickEvent"
              >
                更新履歴&emsp;&gt;
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <!-- /更新履歴 -->

        <!-- 登録テンプレート編集用 -->
        <template
          v-if="loadByEmission"
        >
          <v-card-text>

            <!-- 排出事業者, 排出事業場 -->
            <v-row>
              <v-col
                cols="12"
                md="4"
                class="pt-0"
              >
                <div class="overline">
                  排出事業者
                </div>
                <h4
                  :title="entryPatternForm.emission_name"
                  class="font-weight-medium line-clamp one-clamp"
                >
                  {{ entryPatternForm.emission_name }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="pt-0"
              >
                <div class="overline">
                  排出事業場
                </div>
                <h4 class="font-weight-medium line-clamp one-clamp">
                  <span v-if="entryPatternForm.is_shared">
                    -
                  </span>
                  <span v-else>
                  {{ entryPatternForm.location_name }}
                  </span>
                  &nbsp;
                </h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /排出事業者, 排出事業場 -->

            <!-- パターン名, 表示順 -->
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`entry_pattern_name`"
                  name="パターン名"
                  rules="required|max:25"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="entryPatternForm.name"
                    :error-messages="errors"
                    clearable
                    dense
                    label="パターン名"
                    hide-details="auto"
                    outlined
                    persistent-hint
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>パターン名</span>
                      <span class="ml-1">
                        ({{ entryPatternForm.name?.length || 0 }} / 25)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`sort_priority`"
                  name="表示順"
                  :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                >
                  <v-text-field
                    v-model="entryPatternForm.sort_priority"
                    :error-messages="errors"
                    clearable
                    dense
                    label="表示順"
                    hide-details="auto"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    reverse
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>

            </v-row>
            <!-- /パターン名, 表示順 -->

            <!-- 排出選択時にデフォルト利用する, 事業場共通として利用する -->
            <v-row>
              <v-col
                cols="12"
              >
                <v-checkbox
                  v-model="entryPatternForm.is_shared"
                  class="mt-0 mb-0"
                  hide-details="auto"
                  label="事業場共通として利用する"
                  @change="isSharedCheckboxChangeEvent"
                />
              </v-col>
            </v-row>
            <!-- /排出選択時にデフォルト利用する, 事業場共通として利用する -->

          </v-card-text>
          <v-divider />
        </template>
        <!-- /登録テンプレート編集用 -->

        <!--
          編集、複写、登録パターン編集(排出事業者マスタの詳細から)では再選択不可とする.
        -->
        <v-card-title v-if="!editOrderId && !duplicateOrderId && !loadByEmission">
          <v-row>
            <v-col cols="12" md="6">
              <v-btn
                :color="order.form_type === 'master_mode' ? 'primary' : ''"
                block
                large
                elevation="2"
                value="master"
                @click="formTypeButtonClickEvent('master_mode')"
              >
                マスタから登録
              </v-btn>
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                :color="order.form_type === 'free_mode' ? 'primary' : ''"
                block
                large
                elevation="2"
                value="free"
                @click="formTypeButtonClickEvent('free_mode')"
              >
                フリー登録
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- 売上計上しない, 営業担当者, DXE起票担当者 -->
        <v-card-text>
          <!-- 売上計上しない -->
          <v-row>
            <v-col cols="12" md="3">
              <v-checkbox
                v-if="isBilling"
                v-model="order.not_recorded_sales"
                dense
                :disabled="order.form_type === 'free_mode' || callableType === 'general'"
                label="売上計上しない"
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <!-- /売上計上しない -->
          <!-- 営業担当者, DXE起票担当者 -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`master_sales_staff`"
                name="営業担当者"
                rules="max:12"
              >
                <v-combobox
                  v-model="order.sales_staff"
                  :error-messages="errors"
                  :items="salesStaffs"
                  :return-object="false"
                  dense
                  label="営業担当者"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>営業担当者</span>
                    <span class="ml-1">
                      ({{ order.sales_staff?.length || 0 }} / 12)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{errors}"
                :vid="`master_dxe_vote_staff`"
                name="DXE起票担当者"
                rules="max:12"
              >
                <v-combobox
                  v-model="order.dxe_vote_staff"
                  :error-messages="errors"
                  :items="voteStaffs"
                  :return-object="false"
                  dense
                  label="DXE起票担当者"
                  hide-details="auto"
                  outlined
                  persistent-placeholder>
                  >
                  <template v-slot:label>
                    <span>DXE起票担当者</span>
                    <span class="ml-1">({{ order.dxe_vote_staff?.length || 0 }} / 12)</span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /営業担当者, DXE起票担当者 -->
        </v-card-text>
        <!-- /売上計上しない, 営業担当者, DXE起票担当者 -->

        <!-- 排出事業者を選択 -->
        <template
          v-if="order.form_type === 'master_mode'"
        >
          <v-card-title class="pt-0">
            <span style="color: #0074BA">排出事業者{{ editOrderId ? '' : 'を選択' }}</span>
          </v-card-title>
          <v-card-text
            v-if="!editOrderId"
            class="pt-0"
          >
            <infinite-emission-and-location-auto-complete
              ref="emission"
              :supplier-id="order.emission_id"
              :location-id="order.emission_location_id"
              :location-code="order.emission_location_code"
              :supplier-required="true"
              :location-required="!order.use_spot_emission_location && !entryPatternForm.is_shared"
              :location-disabled="order.use_spot_emission_location || entryPatternForm.is_shared"
              :supplier-disabled="loadByEmission"
              :without-general-form="callableType !== 'general'"
              :selectable-ids="selectableSupplierIds"
              :without-invisible="true"
              location-auto-select
              supplier-md="4"
              location-md="4"
              @update:values="supplierChangeCallback"
            >
              <template v-slot:append>
                <v-col
                  v-if="!loadByEmission"
                  cols="12" md="4"
                >
                  <div class="d-flex">
                    <div>
                      <v-btn
                        class="primary"
                        height="40"
                        @click="searchEmissionButtonClickEvent"
                      >
                        排出事業者を検索
                      </v-btn>
                    </div>
                    <div
                      v-if="selectedEmission"
                      class="ml-3"
                    >
                      <div class="float-left mt-2">
                        <v-checkbox
                          v-model="order.use_spot_emission_location"
                          :disabled="entryPatternForm.is_shared"
                          dense
                          hide-details="auto"
                          class="mt-0"
                          small
                          @change="spotEmissionLocationChangeEvent"
                        >
                          <template v-slot:label>
                            <small>スポット排出事業場&emsp;</small>
                          </template>
                        </v-checkbox>
                      </div>
                      <div class="float-left mt-2">
                        <v-btn
                          v-if="order.use_spot_emission_location"
                          small
                          @click="editSpotLocationButtonClickEvent"
                        >
                          <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-col>
              </template>
            </infinite-emission-and-location-auto-complete>
          </v-card-text>
          <v-card-text>
            <v-row
              v-if="selectedEmission"
              dense
            >
              <v-col cols="12" md="4">
                <h3>{{ selectedEmission.name }}</h3>
                <ul style="list-style: none" class="text-small">
                  <li>
                    〒{{ selectedEmission.zip_code }}&emsp;{{ selectedEmission.address }}
                  </li>
                  <li>
                    電話番号: {{ selectedEmission.phone_number || '-' }}
                  </li>
                  <li>
                    メモ:&nbsp;{{ selectedEmission.memo || '-' }}
                  </li>
                  <li>
                    <strong>マスタ区分: {{ selectedEmission.manifest_type | manifest_type_to_label }}</strong>
                  </li>
                </ul>
              </v-col>
              <v-col
                v-if="selectedEmission.location && selectedEmission.location.name"
                cols="12"
                md="4"
              >
                <h3>{{ selectedEmission.location.name }}<span v-if="editOrderId && order.use_spot_emission_location">（スポット排出事業場）</span></h3>
                <ul style="list-style: none" class="text-small">
                  <li>
                    〒{{ selectedEmission.location.zip_code }}&emsp;{{ selectedEmission.location.address }}
                  </li>
                  <li>
                    電話番号: {{ selectedEmission.location.phone_number || '-' }}
                  </li>
                  <li>
                    メモ:&nbsp;{{ selectedEmission.location.memo || '-' }}
                  </li>
                </ul>
              </v-col>
            </v-row>
          </v-card-text>

          <v-row
            v-if="!loadByEmission && !editOrderId"
            dense
            style="padding-left: 24px"
          >
            <v-col cols="12" md="6">
              <order-history
                :emission-id.sync="order.emission_id"
                :emission-location-code.sync="order.emission_location_code"
                :order-type="callableType"
                @reflect:order="reflectHistoryCallback"
              />
            </v-col>
            <v-col cols="12" md="6">
              <entry-pattern
                :key="reloadEntryPatternKey"
                :order-type="callableType"
                :emission-id="order.emission_id"
                :location-id="order.emission_location_id"
                @reflect:pattern="reflectPatternCallback"
              />
            </v-col>
          </v-row>
        </template>
        <!-- /排出事業者を選択 -->

        <!-- 排出事業者を登録 -->
        <template
          v-if="order.form_type === 'free_mode'"
        >
          <v-card-title>
            <span style="color: #0074BA">排出事業者を登録</span>
          </v-card-title>
          <v-card-text>
            <!-- 会社名 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :class="order.form_type === 'free_mode' ? 'requiredMark' : '' "
                  :rules="{ required: (order.form_type === 'free_mode'), max: 60}"
                  :vid="`free_emission_name`"
                  name="会社名"
                >
                  <v-text-field
                    v-model="order.emission_name"
                    :error-messages="errors"
                    dense
                    label="会社名"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）○○○○○株式会社"
                  >
                    <template v-slot:label>
                      <span>会社名</span>
                      <span class="ml-1">
                          ({{ order.emission_name?.length || 0 }} / 60)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /会社名 -->
            <!-- 郵便番号 -->
            <v-row>
              <v-col cols="12" md="5">
                <validation-provider
                  v-slot="{ errors }"
                  :class="order.form_type === 'free_mode' ? 'requiredMark' : '' "
                  :rules="{ required: (order.form_type === 'free_mode'), zip_code: true, max: 8 }"
                  :vid="`free_emission_zip_code`"
                  name="郵便番号"
                >
                  <v-text-field
                    v-model="order.emission_zip_code"
                    :error-messages="errors"
                    dense
                    label="郵便番号"
                    hide-details="auto"
                    hint="ハイフンを含めて入力してください"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    placeholder="例）111-1111"
                  >
                    <template v-slot:label>
                      <span>郵便番号</span>
                      <span class="ml-1">
                        ({{ order.emission_zip_code?.length || 0 }} / 8)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                    <template v-slot:append-outer>
                      <zip-code-search
                        :zip-code="order.emission_zip_code"
                        @zipAddress="setEmissionZipAddress"
                      />
                      &nbsp;
                      <v-btn
                        outlined
                        small
                        @click="searchFreeEmissionZipButtonClickEvent"
                      >
                        住所→郵便番号
                      </v-btn>
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /郵便番号 -->
            <!-- 都道府県／市区町村 -->
            <v-row>
              <v-col cols="12" md="3">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_prefecture_code`"
                  class="requiredMark"
                  name="都道府県"
                  rules="required"
                >
                  <v-autocomplete
                    v-model="order.emission_prefecture_code"
                    :error-messages="errors"
                    :items="prefList"
                    dense
                    hide-details="auto"
                    item-text="text"
                    item-value="value"
                    label="都道府県"
                    outlined
                    persistent-placeholder
                    placeholder="例）東京都"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_address_1`"
                  class="requiredMark"
                  name="市区町村"
                  rules="required|full_width|max:20"
                >
                  <v-text-field
                    v-model="order.emission_address_1"
                    :error-messages="errors"
                    dense
                    label="市区町村"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    required
                    placeholder="例）中央区"
                  >
                    <template v-slot:label>
                      <span>市区町村</span>
                      <span class="ml-1">
                          ({{ order.emission_address_1?.length || 0 }} / 20)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /都道府県／市区町村 -->
            <!-- 町域 -->
            <v-row>
              <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_address_2`"
                  name="町域"
                  rules="full_width|max:40"
                >
                  <v-text-field
                    v-model="order.emission_address_2"
                    :error-messages="errors"
                    dense
                    label="町域"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）日本橋兜町"
                  >
                    <template v-slot:label>
                      <span>町域</span>
                      <span class="ml-1">
                          ({{ order.emission_address_2?.length || 0 }} / 40)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /町域 -->
            <!-- 詳細住所 -->
            <v-row>
              <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_address_3`"
                  name="詳細住所"
                  rules="max:50"
                >
                  <v-text-field
                    v-model="order.emission_address_3"
                    :error-messages="errors"
                    dense
                    label="詳細住所"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）１−２−３　○○ビル○階"
                  >
                    <template v-slot:label>
                      <span>町域</span>
                      <span class="ml-1">
                        ({{ order.emission_address_3?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /詳細住所 -->
            <!-- 電話番号 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_phone_number`"
                  name="電話番号"
                  rules="numeric_hyphen_only|min:2|max:15"
                >
                  <v-text-field
                    v-model="order.emission_phone_number"
                    :error-messages="errors"
                    dense
                    label="電話番号"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    hint="電話番号を「-」ハイフン「( )」込みで入力します"
                    persistent-hint
                    placeholder="例）000-0000-0000"
                  >
                    <template v-slot:label>
                      <span>電話番号</span>
                      <span class="ml-1">
                          ({{ order.emission_phone_number?.length || 0 }} / 15)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /電話番号 -->
          </v-card-text>
          <v-card-title>
            <span style="color: #0074BA">事業場を登録</span>
          </v-card-title>
          <v-card-text>
            <!-- 事業場名 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_location_name`"
                  class="requiredMark"
                  name="事業場名"
                  rules="required|max:60"
                >
                  <v-text-field
                    v-model="order.emission_location_name"
                    :error-messages="errors"
                    dense
                    label="事業場名"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）○○○○○株式会社"
                    required
                  >
                    <template v-slot:label>
                      <span>事業場名</span>
                      <span class="ml-1">
                          ({{ order.emission_location_name?.length || 0 }} / 60)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <v-btn
                  color="primary"
                  @click="copyEmissionToEmissionLocationButtonClickEvent"
                >
                  排出事業者情報を事業場にコピー
                </v-btn>
              </v-col>
            </v-row>
            <!-- /事業場名 -->
            <!-- 郵便番号 -->
            <v-row>
              <v-col cols="12" md="5">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_location_zip_code`"
                  class="requiredMark"
                  name="郵便番号"
                  rules="required|zip_code|max:8"
                >
                  <v-text-field
                    v-model="order.emission_location_zip_code"
                    :error-messages="errors"
                    dense
                    label="郵便番号"
                    hide-details="auto"
                    hint="ハイフンを含めて入力してください"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    placeholder="例）111-1111"
                  >
                    <template v-slot:label>
                      <span>郵便番号</span>
                      <span class="ml-1">
                          ({{ order.emission_location_zip_code?.length || 0 }} / 8)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                    <template v-slot:append-outer>
                      <zip-code-search
                        :zip-code="order.emission_location_zip_code"
                        button-size="small"
                        @zipAddress="setEmissionLocationZipAddress"
                      />
                      &nbsp;
                      <v-btn
                        outlined
                        small
                        @click="searchFreeEmissionLocationZipButtonClickEvent"
                      >
                        住所→郵便番号
                      </v-btn>
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /郵便番号 -->
            <!-- 都道府県／市区町村 -->
            <v-row>
              <v-col cols="12" md="3">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{required: true}"
                  :vid="`free_emission_location_prefecture_code`"
                  class="requiredMark"
                  name="都道府県"
                >
                  <v-autocomplete
                    v-model="order.emission_location_prefecture_code"
                    :error-messages="errors"
                    :items="prefList"
                    dense
                    hide-details="auto"
                    item-text="text"
                    item-value="value"
                    label="都道府県"
                    outlined
                    persistent-placeholder
                    placeholder="例）東京都"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_location_address_1`"
                  class="requiredMark"
                  name="市区町村"
                  rules="required|full_width|max:20"
                >
                  <v-text-field
                    v-model="order.emission_location_address_1"
                    :error-messages="errors"
                    dense
                    label="市区町村"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）中央区"
                  >
                    <template v-slot:label>
                      <span>市区町村</span>
                      <span class="ml-1">
                          ({{ order.emission_location_address_1?.length || 0 }} / 20)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /都道府県／市区町村 -->
            <!-- 町域 -->
            <v-row>
              <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_location_address_2`"
                  name="町域"
                  rules="full_width|max:40"
                >
                  <v-text-field
                    v-model="order.emission_location_address_2"
                    :error-messages="errors"
                    dense
                    label="町域"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）日本橋兜町"
                  >
                    <template v-slot:label>
                      <span>町域</span>
                      <span class="ml-1">
                          ({{ order.emission_location_address_2?.length || 0 }} / 40)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /町域 -->
            <!-- 詳細住所 -->
            <v-row>
              <v-col md="9">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_location_address_3`"
                  name="事業場 詳細住所"
                  rules="max:50"
                >
                  <v-text-field
                    v-model="order.emission_location_address_3"
                    :error-messages="errors"
                    dense
                    label="詳細住所"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）１−２−３　○○ビル○階"
                  >
                    <template v-slot:label>
                      <span>詳細住所</span>
                      <span class="ml-1">
                          ({{ order.emission_location_address_3?.length || 0 }} / 50)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /詳細住所 -->
            <!-- 電話番号 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :vid="`free_emission_location_phone_number`"
                  name="電話番号"
                  rules="numeric_hyphen_only|min:2|max:15"
                >
                  <v-text-field
                    v-model="order.emission_location_phone_number"
                    :error-messages="errors"
                    dense
                    label="電話番号"
                    hide-details="auto"
                    hint="電話番号を「-」ハイフン「( )」込みで入力します"
                    outlined
                    persistent-placeholder
                    persistent-hint
                    placeholder="例）000-0000-0000"
                  >
                    <template v-slot:label>
                      <span>電話番号</span>
                      <span class="ml-1">
                          ({{ order.emission_location_phone_number?.length || 0 }} / 15)
                        </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /電話番号 -->
          </v-card-text>
        </template>
        <!-- /排出事業者を登録 -->

        <!-- 過去マニフェストの起票, 回収日, 希望時間(開始), 希望時間(終了), 繰り返し設定, 複写個数, 曜日, 期間終了日 -->
        <v-card-title class="pt-0">
          <span style="color: #0074BA">回収日</span>
        </v-card-title>
        <v-card-text class="pt-0">
          <v-row dense>
            <v-col cols="12" md="3">
              <v-checkbox
                v-if="!hidePastManifest"
                v-model="order.past_manifest"
                :disabled="loadByEmission || order.repeat_setting === 'select_date'"
                dense
                label="過去マニフェストの起票"
                hide-details="auto"
                @click="pastManifestChangeEvent"
              />
            </v-col>
          </v-row>

          <!-- 回収日, 希望時間 -->
          <v-row>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="order.collected_date"
                :minimum-date="minCollectedDate"
                :maximum-date="maxCollectedDate"
                :disabled="order.repeat_setting === 'select_date'"
                @dateChangedCallback="dateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{
                      required: order.past_manifest || order.repeat_setting === 'select_date',
                      collectedDateCheck: {past_manifest: order.past_manifest}
                    }"
                    name="回収日"
                    :class="order.past_manifest || order.repeat_setting === 'select_date' ? 'requiredMark' : '' "
                  >
                    <v-text-field
                      v-model="order.collected_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      :disabled="loadByEmission || order.repeat_setting === 'select_date'"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="回収日"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      readonly
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <!-- /回収日 -->

            <!-- 希望時間 -->
            <v-col cols="12" md="2">
              <validation-provider
                v-slot="{ errors }"
                :rules="{preferredStartTimeCheck: {preferred_end_time: order.preferred_end_time}}"
                name="希望開始時間"
              >
                <vue-ctk-date-time-picker
                  v-model="order.preferred_start_time"
                  minute-interval="15"
                  no-value-to-custom-elem
                  only-time
                  color="#0070B3"
                  format="HH:mm"
                  formatted="HH:mm"
                >
                  <v-text-field
                    v-model="order.preferred_start_time"
                    :error-messages="errors"
                    append-icon="mdi-clock-time-four-outline"
                    clearable
                    dense
                    hide-details="auto"
                    label="希望開始時間"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    placeholder="--:--"
                    readonly
                  />
                </vue-ctk-date-time-picker>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="2">
              <vue-ctk-date-time-picker
                v-model="order.preferred_end_time"
                minute-interval="15"
                color="#0070B3"
                format="HH:mm"
                formatted="HH:mm"
                only-time
                no-value-to-custom-elem
              >
                <v-text-field
                  v-model="order.preferred_end_time"
                  append-icon="mdi-clock-time-four-outline"
                  clearable
                  outlined
                  label="希望終了時間"
                  dense
                  persistent-placeholder
                  hide-details="auto"
                  placeholder="--:--"
                  readonly
                />
              </vue-ctk-date-time-picker>
            </v-col>
          </v-row>
          <!-- 回収日, 希望時間 -->

          <!-- 繰り返し設定 -->
          <v-row
            v-if="loadBy !== 'driver_schedule' && !loadByEmission"
          >
            <v-col cols="12" md="4">
              <p class="mb-1">
                繰り返し設定
              </p>
              <v-radio-group
                v-model="order.repeat_setting"
                row
                dense
                hide-details="auto"
                class="mt-1"
              >
                <v-radio
                  v-for="n in repeatSettings"
                  :key="n.value"
                  :label="n.text"
                  :value="n.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- /繰り返し設定 -->

          <!-- 複製個数 -->
          <v-row
            v-if="order.repeat_setting === 'multi_copy'"
          >
            <v-col cols="12" md="2">
              <validation-provider
                v-slot="{ errors }"
                :vid="`copy_count`"
                class="requiredMark"
                rules="required"
                name="複製個数"
              >
                <v-select
                  v-model="order.copy_count"
                  label="複製個数"
                  :items="[2,3,4,5,6,7,8,9,10]"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  style="font-size: 80%"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /複製個数 -->

          <!-- 選択された日付リスト -->
          <v-row v-if="order.repeat_setting === 'select_date'">
            <v-col cols="12" md="9">
              <validation-provider
                v-slot="{ errors }"
                vid="selected_collected_dates"
                class="requiredMark"
                name="選択された日付"
                rules="required"
              >
                <v-text-field
                  v-model="selected_collected_dates_display"
                  :error-messages="errors"
                  label="選択された日付"
                  dense
                  outlined
                  readonly
                  hide-details="auto"
                  persistent-placeholder
                  filled
                />
              </validation-provider>
            </v-col>
            <!-- 日付選択ボタン -->
            <v-col cols="12" md="2">
              <v-btn
                class="primary"
                height="40"
                @click="openDateSelectDialog"
              >
                日付選択
              </v-btn>
            </v-col>
            <!-- /日付選択ボタン -->
          </v-row>
          <!-- /選択された日付リスト -->
        </v-card-text>
        <!-- 過去マニフェストの起票, 回収日, 希望時間(開始), 希望時間(終了), 繰り返し設定, 複写個数, 曜日, 期間終了日 -->

        <!-- 指示メモ, 備考, 検索キーワード -->
        <v-card-title
          v-if="['collection', 'general'].includes(callableType)"
          class="pt-0"
        >
          <span style="color: #0074BA">指示メモ</span>
        </v-card-title>
        <v-card-text class="pt-0">
          <!-- ドライバー指示メモ -->
          <v-row
            v-if="['collection', 'general'].includes(callableType) && !loadByEmission"
          >
            <v-col cols="12" :md="driverInstructionMd">
              <validation-provider
                v-slot="{ errors }"
                name="ドライバー指示メモ"
                rules="max:300"
              >
                <v-textarea
                  v-model="order.driver_instruction"
                  :error-messages="errors"
                  hide-details="auto"
                  label="ドライバー指示メモ"
                  no-resize
                  outlined
                  persistent-placeholder
                  required
                  rows="2"
                >
                  <template v-slot:label>
                    <span>ドライバー指示メモ</span>
                    <span class="ml-1">
                      ({{ order.driver_instruction?.length || 0 }} / 300)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-textarea>
              </validation-provider>
            </v-col>
          <!-- /ドライバー指示メモ -->
          <!-- 添付ファイル -->
            <v-col cols="12" md="3">
              <dropzone-file
                :max-size="MANIFEST_ATTACHMENT.MAX_SIZE"
                :accepts="MANIFEST_ATTACHMENT.ACCEPTS"
                :max-file-size="MANIFEST_ATTACHMENT.MAX_FILE_SIZE"
                :alt-file-size-format="MANIFEST_ATTACHMENT.ALT_FILE_SIZE_FORMAT"
                :alt-file-format="MANIFEST_ATTACHMENT.ALT_FILE_FORMAT"
                :immediate-delete="MANIFEST_ATTACHMENT.IMMEDIATE_DELETE"
                :files.sync="files"
                :hide-thumbnail="true"
                :simple="true"
                :hide-in-max-file="false"
              />
            </v-col>
            <v-col cols="12" :md="attachmentViewerMd">
              <viewer
                v-if="activeFiles.length > 0"
                :images="activeFiles"
                :options="viewerOptions"
                class="images clearfix"
              >
                <template v-slot="scope">
                  <figure class="images" style="display: flex; flex-wrap: wrap; gap: 8px;">
                    <template
                      v-for="(attachment, index) in scope.images"
                    >
                      <div
                        v-if="!attachment._destroy"
                        :key="attachment.id || attachment.url || index"
                        class="image-wrapper"
                        style="border: 1px solid #ddd;border-radius: 5px;position: relative;width: 100px;min-width: 100px;max-width: 100px;text-align: center;height: 67px;flex-shrink: 0;"
                      >
                        <div style="position: absolute;top: -10px;right: -10px;z-index:100;">
                          <v-btn
                            color="error"
                            icon
                            @click="removeFile(attachment)"
                          >
                            <v-icon>mdi-close-circle</v-icon>
                          </v-btn>
                        </div>
                        <img
                          v-if="isImageContent(attachment.content_type)"
                          :alt="index"
                          :data-source="attachment.url"
                          :src="attachment.url"
                          class="image"
                          style="width: 100%;height: 100%;object-fit: contain;"
                        >
                        <template
                          v-else
                        >
                          <div class="text-center">
                            <v-icon
                              size="65"
                            >
                              {{ documentIcon(attachment.content_type) }}
                            </v-icon>
                          </div>
                        </template>
                      </div>
                    </template>
                  </figure>
                </template>
              </viewer>
            </v-col>
          </v-row>
          <!-- /添付ファイル -->

          <!-- 検索キーワード -->
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                name="検索キーワード"
                rules="max:25"
              >
                <v-text-field
                  v-model="order.keyword"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="検索キーワード"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>検索キーワード</span>
                    <span class="ml-1">
                          ({{ order.keyword?.length || 0 }} / 25)
                        </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /検索キーワード -->
        </v-card-text>
        <!-- /指示メモ, 備考, 検索キーワード -->

        <!-- マニフェスト区分, 引渡担当者, 登録担当者, 運搬担当者, 運搬方法, 車両番号 -->
        <v-card-title>
          <span style="color: #0074BA">マニフェスト</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <!-- callableTypeがgeneralの場合はラベル表示 -->
              <div v-if="callableType === 'general'">
                <p class="mb-1">一般廃棄物</p>
              </div>
              <!-- それ以外は選択可能 -->
              <v-radio-group
                v-else
                v-model="order.manifest_type"
                :disabled="order.form_type === 'master_mode'"
                row
                dense
                hide-details="auto"
                class="mt-0"
              >
                <v-radio
                  v-for="n in dispManifestTypes"
                  :key="n.value"
                  :value="n.value"
                >
                  <template v-slot:label>
                    <label :class="{ 'radio-selected': order.manifest_type === n.value }">{{ n.text }}</label>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- 引渡担当者/登録担当者 -->
          <v-row v-if="order.form_type === 'master_mode'">
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :class="order.manifest_type === 'dxe_form' ? 'requiredMark' : '' "
                :rules="{ required: order.manifest_type === 'dxe_form',  max: 12 }"
                :vid="`master_deliver_staff`"
                name="引渡担当者"
              >
                <v-combobox
                  v-model="order.deliver_staff"
                  :error-messages="errors"
                  :items="emissionDeliverers"
                  :return-object="false"
                  dense
                  label="引渡担当者"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>引渡担当者</span>
                    <span class="ml-1">
                          ({{ order.deliver_staff?.length || 0 }} / 12)
                        </span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`master_register_staff`"
                name="登録担当者"
                rules="max:12"
              >
                <v-combobox
                  v-model="order.register_staff"
                  :error-messages="errors"
                  :items="emissionRegisters"
                  :return-object="false"
                  dense
                  label="登録担当者"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>登録担当者</span>
                    <span class="ml-1">
                          ({{ order.register_staff?.length || 0 }} / 12)
                        </span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`free_deliver_staff`"
                name="引渡担当者"
                rules="max:12"
              >
                <v-text-field
                  v-model="order.deliver_staff"
                  :error-messages="errors"
                  dense
                  label="引渡担当者"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）引渡　太郎"
                >
                  <template v-slot:label>
                    <span>引渡担当者</span>
                    <span class="ml-1">
                          ({{ order.deliver_staff?.length || 0 }} / 12)
                        </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`free_register_staff`"
                name="登録担当者"
                rules="max:12"
              >
                <v-text-field
                  v-model="order.register_staff"
                  :error-messages="errors"
                  dense
                  label="登録担当者"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）登録　太郎"
                >
                  <template v-slot:label>
                    <span>登録担当者</span>
                    <span class="ml-1">
                          ({{ order.register_staff?.length || 0 }} / 12)
                        </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /引渡担当者/登録担当者 -->

          <!-- 運搬担当者／運搬方法／車両番号 -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`transport_user_name`"
                :rules="{ max: 12 }"
                name="運搬担当者"
              >
                <v-combobox
                  v-model="order.transport_user_name"
                  :error-messages="errors"
                  :items="drivers"
                  :return-object="false"
                  clearable
                  dense
                  hide-details="auto"
                  item-value="text"
                  label="運搬担当者"
                  outlined
                  persistent-placeholder
                  @click:clear="transportUserClearClickEvent"
                  @change="transportUserChangeEvent"
                >
                  <template v-slot:label>
                    <span>運搬担当者</span>
                    <span class="ml-1">
                          ({{ order.transport_user_name?.length || 0 }} / 12)
                        </span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>

            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`transportation_id`"
                name="運搬方法"
              >
                <v-select
                  v-model="order.transportation_id"
                  :error-messages="errors"
                  :items="transportations"
                  dense
                  clearable
                  hide-details="auto"
                  label="運搬方法"
                  outlined
                  persistent-placeholder
                ></v-select>
              </validation-provider>
            </v-col>

            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`vehicle_number`"
                name="車両番号"
                rules="max:15"
              >
                <v-combobox
                  v-model="order.vehicle_number"
                  :error-messages="errors"
                  :items="vehicles"
                  :return-object="false"
                  :clearable="true"
                  item-text="number"
                  item-value="number"
                  dense
                  label="車両番号"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>車両番号</span>
                    <span class="ml-1">
                          ({{ order.vehicle_number?.length || 0 }} / 15)
                        </span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /運搬担当者／運搬方法／車両番号 -->
        </v-card-text>
        <!-- マニフェスト区分, 引渡担当者, 登録担当者, 運搬担当者, 運搬方法, 車両番号 -->
        <sales-item-block
          :callable-type="callableType"
          :emission-id="order.emission_id"
          :manifests.sync="order.manifests"
          :quantity-units="quantityUnits"
          :hazardous-substances="hazardousSubstances"
          :quantity-confirms="quantityConfirms"
          :items="items"
          :packings="packings"
          :transportations="transportations"
          :disposal-methods="disposalMethods"
          :master-mode="order.form_type === 'master_mode'"
          :dxe-manifest="order.manifest_type === 'dxe_form'"
          :manifest-type="order.manifest_type"
          :selectedEmission="selectedEmission"
          :freeTypeEmission="freeTypeEmission"
          :load-by-emission="loadByEmission"
          ref="salesItemBlock"
          @addManifestCallback="addManifestCallback"
          @changeManifestTypeCallback="changeManifestTypeCallback"
        />
        <v-divider />
        <v-card-text class="py-2">
          <div class="text-body-2 text-right">
            引渡日：{{ footerCollectedDateLabel }} / マニフェスト区分：{{ footerManifestTypeLabel }}
          </div>
        </v-card-text>
        <v-card-actions v-if="!['driver_schedule', 'emission'].includes(this.loadBy)" style="display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; gap: 8px;">
          <!-- 左: 空白 (中央寄せのためのスペーサー) -->
          <div></div>
          <!-- 中央: パターンに追加 -->
          <add-entry-pattern-modal
            :order-type="callableType"
            :emission-id="order.emission_id"
            :emission-name="selectedEmission?.name"
            :location-id="order.emission_location_id"
            :location-name="selectedEmission?.location?.name"
            :order="order"
            :is-spot="order.use_spot_emission_location"
            @register:pattern="registerPatternCallback"
          />
          <!-- 右: その他ボタン群 -->
          <div style="display: flex; justify-content: flex-end; gap: 8px; flex-wrap: wrap; align-items: center;">
          <v-button-processing
            v-if="order.status === 'collection_accepted' && (order.active_remand_manifest || order.await_approval_manifest)"
            :onclick="approvalOrderButtonClickEvent"
            :key="`approvalOrderButton-${reloadKey}`"
            color="primary"
            elevation="5"
          >
            排出再申請
          </v-button-processing>
          <v-btn
            @click="cancelButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-button-processing
            v-if="callableType === 'self_emission' && order.status === 'collection_accepted'"
            :onclick="selfEmissionReservationButtonClickEvent"
            :key="`selfEmissionReservationButton-${reloadKey}`"
            color="primary"
            elevation="5"
          >
            予約登録
          </v-button-processing>

          <template v-if="order.status !== 'collection_accepted'">
            <VButtonProcessing
              v-if="selectedEmission && selectedEmission.approval_type === 'use_approval' && order.past_manifest === true && callableType !== 'general'"
              :onclick="registerApprovalButtonClickEvent"
              :key="`registerApprovalButton-${reloadKey}`"
              color="primary"
              elevation="5"
            >
              排出者申請
            </VButtonProcessing>

            <VButtonProcessing
              v-else
              :onclick="registerOrderButtonClickEvent"
              :key="`registerOrderButton-${reloadKey}`"
              color="primary"
              elevation="5"
            >
              受注登録
            </VButtonProcessing>
          </template>
          <VButtonProcessing
            v-if="order.status !== 'collection_accepted'"
            :onclick="temporarySaveButtonClickEvent"
            :key="`temporarySaveButton-${reloadKey}`"
            color="primary"
            elevation="5"
          >
            仮保存
          </VButtonProcessing>
          <VButtonProcessing
            v-if="order.status === 'collection_accepted'"
            :onclick="registerOrderButtonClickEvent"
            :key="`registerOrderButton-${reloadKey}`"
            color="primary"
            elevation="5"
          >
            保存
          </VButtonProcessing>
          </div>
        </v-card-actions>
      </v-card>
    </validation-observer>

    <search-emission-dialog
      :enable-dialog="enableSearchEmissionDialog"
      :emission-filter="callableType === 'general' ? 'all' : 'exclude_general'"
      @cancelCallback="searchEmissionDialogCancelCallback"
      @registerCallback="reflectEmissionCallback"
    />

    <!-- スポット排出事業場入力モーダル -->
    <spot-emission-location-dialog
      :enable-dialog="enableEditSpotLocation"
      :master-emission=this.selectedEmission
      :location="spotLocation"
      @closeCallback="spotLocationCancelCallback"
      @registerCallback="spotLocationRegisterCallback"
    />
    <!-- /スポット排出事業場入力モーダル -->

    <confirm ref="confirm" />
    <!-- 登録確認モーダル -->
    <registration-provisional-dialog
      :enable-dialog="enableRegistrationProvisionalDialog"
      :enable-to-deal-button="!order.not_recorded_sales"
      :from-collection-request="false"
      :emission-approval="emissionApproval"
      :repeatSetting="order.repeat_setting"
      :including-paper="includingPaper"
      @closeCallback="registrationProvisionalDialogCloseCallback"
      @registerCallback="registrationProvisionalRegisterCallback"
    />
    <!-- /登録確認モーダル -->
    <revision-history-dialog
      :enable-dialog="showUpdateHistoryDialog"
      :order="order"
      @closeUpdateHistoryModal="closeUpdateHistoryModal"
    />

    <send-mail-approval-dialog
      :enable-dialog="enableMailApprovalDialog"
      :order-id="targetOrderId"
      :after-transaction="afterSaveMove"
      :must-save="mustSave"
      @closeCallback="closeDialogCallback"
      @registerCallback="dialogRegisterCallBack"
    />
    <send-mail-confirmable-dialog
      :enable-dialog="enableMailConfirmableDialog"
      :order-id="targetOrderId"
      :after-transaction="afterSaveMove"
      :must-save="mustSave"
      @negativeCallback="closeDialogCallback"
      @positiveCallback="dialogRegisterCallBack"
    />

    <v-snackbar
      v-model="manifestTypeMismatchAlert"
      :timeout="-1"
      color="error"
      width="900"
    >
      <div v-html="manifestTypeMismatchMessage"></div>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="manifestTypeMismatchAlert = false"
        >
          閉じる
        </v-btn>
      </template>
    </v-snackbar>

    <search-free-emission-zip-modal
      :enable="enableSearchFreeEmissionZipModal"
      :initial-prefecture-code="order.emission_prefecture_code"
      :initial-city-name="order.emission_address_1"
      :initial-town-name="order.emission_address_2"
      @reflectFullCallback="reflectFreeEmissionFullCallback"
      @reflectZipCallback="reflectFreeEmissionZipCallback"
      @closeCallback="closeModalCallback"
    />

    <search-free-emission-location-zip-modal
      :enable="enableSearchFreeEmissionLocationZipModal"
      :initial-prefecture-code="order.emission_location_prefecture_code"
      :initial-city-name="order.emission_location_address_1"
      :initial-town-name="order.emission_location_address_2"
      @reflectFullCallback="reflectFreeEmissionLocationFullCallback"
      @reflectZipCallback="reflectFreeEmissionLocationZipCallback"
      @closeCallback="closeModalCallback"
    />

    <!-- 日付選択ダイアログ -->
    <collected-selected-dialog
      :enable-dialog="dateSelectDialog"
      :min-collected-date="minCollectedDate"
      :max-collected-date="maxCollectedDate"
      :initial-selected-dates="order.selected_collected_dates"
      @closeCallback="closeDateSelectDialog"
      @applyCallback="applyDateSelectCallback"
    />
    <!-- /日付選択ダイアログ -->

  </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import _ from 'lodash'
import RevisionHistoryDialog from './dialogs/_RevisionHistoryDialog'
import RegistrationProvisionalDialog from '../dialogs/_RegistrationProvisional'
import SearchEmissionDialog from '../../../dialogs/_SearchEmissionDialog'
import SpotEmissionLocationDialog from "@/driver/pages/dialogs/_SpotEmissionLocationDialog.vue";
import SendMailApprovalDialog from '@/driver/pages/orders/accepts/collection/dialogs/_SendMailApprovalDialog'
import VButtonProcessing from '@/components/VButtonProcessing.vue'
import SendMailConfirmableDialog from '@/driver/pages/orders/accepts/collection/dialogs/_SendMailConfirmableDialog.vue'
import SalesItemBlock from '../../components/_SalesItemBlock'
import PrefectureList from '../../../../../mixins/PrefectureList'
import DropzoneFile from '../../../../../components/DropzoneFile'
import ZipCodeSearch from '@/components/ZipCodeSearch'
import SearchFreeEmissionZipModal from "@/driver/components/SearchZipModal.vue";
import SearchFreeEmissionLocationZipModal from "@/driver/components/SearchZipModal.vue";
import { MANIFEST_ATTACHMENT } from '@/constants/appConst'
import Confirm from "../../../../../components/Confirm"
import InfiniteEmissionAndLocationAutoComplete from "@/driver/components/InfiniteEmissionAndLocationAutoComplete.vue";
import OrderHistory from './_OrderHistory.vue'
import EntryPattern from './_EntryPattern.vue'
import AddEntryPatternModal from "@/driver/pages/orders/accepts/collection/dialogs/AddEntryPatternModal.vue";
import CollectedSelectedDialog from "@/driver/pages/orders/accepts/collection/dialogs/_CollectedSelectedDialog.vue";
import EntryPatternBuilderMixin from "@/mixins/driver/entry-pattern-builder-mixin";
import { component as Viewer } from 'v-viewer'
import 'viewerjs/dist/viewer.css'

export default {
  name: 'DriverOrderAcceptForm',
  components: {
    AddEntryPatternModal,
    CollectedSelectedDialog,
    InfiniteEmissionAndLocationAutoComplete,
    SpotEmissionLocationDialog,
    VButtonProcessing,
    RegistrationProvisionalDialog,
    SendMailConfirmableDialog,
    SendMailApprovalDialog,
    SearchEmissionDialog,
    DropzoneFile,
    SalesItemBlock,
    ZipCodeSearch,
    Confirm,
    RevisionHistoryDialog,
    SearchFreeEmissionZipModal,
    SearchFreeEmissionLocationZipModal,
    OrderHistory,
    EntryPattern,
    Viewer,
  },
  mixins: [
    PrefectureList,
    EntryPatternBuilderMixin
  ],
  props: {
    /**
     * 編集用受注ID
     */
    editOrderId: {
      type: Number,
      default: null,
    },
    /**
     * 複写用受注ID
     */
    duplicateOrderId: {
      type: Number,
      default: null,
    },
    entryPatternId: {
      type: Number,
      default: null,
    },
    entryPatternEmissionId: {
      type: Number,
      default: null,
    },
    /**
     * 動作モード
     * collection: 受注登録
     * self_emission: 排出自己運搬
     * proxy_request: 他社運搬
     * general: 一般廃棄物
     */
    callableType: {
      type: String,
      default: 'collection',
    },
    /**
     * 呼び出し元
     * order: 受注登録
     * driver_schedule: ドライバースケジュール
     * emission: 排出事業者詳細(登録パターンの編集)
     * @type {String}
     * @default order
     */
    loadBy: {
      type: String,
      default: 'order'
    },
    /**
     * ドライバースケジュール
     * 対象日(回収日)
     * @type {String}
     * @default null
     */
    driverScheduleTargetDate: {
      type: String,
      default: null,
    },
    /**
     * ドライバースケジュール
     * 運搬担当者ID
     * @type {Number}
     * @default null
     */
    driverScheduleTransportUserId: {
      type: Number,
      default: null,
    },
    /**
     * ドライバースケジュール
     * 運搬担当者名
     * @type {String}
     * @default null
     */
    driverScheduleTransportUserName: {
      type: String,
      default: null,
    },
    /**
     * 「過去マニフェストの起票」の表示設定
     * ドライバースケジュールにて未来日から呼び出した場合を想定した制御
     */
    hidePastManifest: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      environment: process.env.VUE_APP_ENV,
      systemDate: this.$dayjs().format("YYYY-MM-DD"),
      notRecordedSalesByMasterMode: false,
      enableRegistrationProvisionalDialog: false,
      enableMailConfirmableDialog: false,
      enableEditSpotLocation: false,
      enableSearchFreeEmissionZipModal: false,
      enableSearchFreeEmissionLocationZipModal: false,
      tab: null,
      salesItemPrices: null,
      order: null,
      repeatSettings: null,
      /** 選択された排出事業者情報 */
      selectedEmission: null,
      backupSelectedEmission: null,
      /** 引渡担当者 */
      emissionDeliverers: null,
      /** 登録担当者 */
      emissionRegisters: null,
      /** 排出事業場ヘッダー項目 */
      tableHeaders: [
        { value: 'name', text: '事業場名' },
        { value: 'address', text: '住所' },
        { value: 'phone_number', text: '電話番号' },
      ],
      files: [],
      salesStaffs: [],
      enableSearchEmissionDialog: false,
      searchEmissions: null,
      spotLocation: null,
      quantityUnits: [],
      hazardousSubstances: [],
      quantityConfirms: [],
      items: [],
      packings: [],
      transportRoutes: [],
      allTransportRoutes: [],
      transportations: [],
      disposalMethods: [],
      manifestTypes: [],
      dispManifestTypes: [],
      drivers: [],
      vehicles: [],
      voteStaffs: [],
      targetOrderId: null,
      afterSaveMove: false,
      mustSave: false,
      sendSave: false,
      showUpdateHistoryDialog: false,
      emissionApproval: false,
      includingPaper: false,
      enableMailApprovalDialog: false,
      manifestTypeMismatchAlert: false,
      manifestTypeMismatchMessage: null,
      reloadKey: 0,
      selectableSupplierIds: [],
      reloadEntryPatternKey: 0,
      stopLocationAutoSelect: false,
      /* デフォルトが存在する場合の保持変数 */
      retentionOrder: null,

      /* 日付選択ダイアログ用 */
      dateSelectDialog: false,
      selected_collected_dates_display: '',
      viewerOptions: {
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: false,
        zoomable: false,
        rotatable: false,
        fullscreen: true,
      },
      entryPatternForm: {
        name: null,
        emission_name: null,
        location_name: null,
        location_id: null,
        is_shared: false,
        sort_priority: 0,
      },
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
    }),
    MANIFEST_ATTACHMENT() {
      return MANIFEST_ATTACHMENT
    },
    activeFiles () {
      return (this.files || []).filter((file) => !file._destroy)
    },
    driverInstructionMd () {
      const count = this.activeFiles.length

      if (count === 0) return 9
      if (count === 1) return 7
      if (count === 2) return 6
      return 5
    },
    attachmentViewerMd () {
      const count = this.activeFiles.length

      if (count === 0) return 0
      if (count === 1) return 2
      if (count === 2) return 3
      return 4
    },
    /**
     * 回収日
     * 最小日付を算出
     * @returns {string}
     */
    minCollectedDate () {
      return this.$dayjs(this.order.created_date).subtract(10, 'years').format('YYYY-MM-DD')
    },
    /**
     * 回収日
     * 最大日付を算出
     * @returns {string}
     */
    maxCollectedDate () {
      return this.$dayjs(this.order.created_date).add(5, 'years').format("YYYY-MM-DD")
    },
    loadByEmission () {
      return this.loadBy === 'emission'
    },
    /**
     * フッター表示用の引渡日ラベル
     * 未設定は「ー」、複数日付選択時は先頭日付に「等」を付与
     */
    footerCollectedDateLabel () {
      if (!this.order) {
        return 'ー'
      }

      const selectedDates = this.order.selected_collected_dates || []
      const collectedDate = this.order.collected_date || selectedDates[0]

      if (!collectedDate) {
        return 'ー'
      }

      return selectedDates.length > 1 ? `${collectedDate} 等` : collectedDate
    },
    /**
     * フッター表示用のマニフェスト区分ラベル
     * 選択値から表示名を解決し、解決できない場合は「ー」を表示する
     */
    footerManifestTypeLabel () {
      if (!this.order || !this.order.manifest_type) {
        return 'ー'
      }

      const selectedType = this.manifestTypes?.find((v) => v.value === this.order.manifest_type)
      return selectedType?.text || 'ー'
    },
    /**
     * 排出持込時のフリーモードで入力された排出事業者情報を生成
     */
    freeTypeEmission () {
      if (this.order.form_type === 'free_mode') {
        return {
          emission_name: this.order.emission_name,
          emission_zip_code: this.order.emission_zip_code,
          emission_prefecture_code: this.order.emission_prefecture_code,
          emission_address_1: this.order.emission_address_1,
          emission_address_2: this.order.emission_address_2,
          emission_address_3: this.order.emission_address_3,
          emission_phone_number: this.order.emission_phone_number,
          subscriber_number: null,
        }
      }
      return {}
    },
  },
  watch: {
    /**
     * 排出事業者選択による制御
     * @param newVal
     */
    'selectedEmission': function (newVal) {
      // 何もない場合、排出事業者と引渡担当者、登録担当者をクリア
      if (newVal === null || newVal.id === null) {
        this.emissionDeliverers = []
        this.emissionRegisters = []
        this.selectedEmission = null
      } else {
        this.selectedEmission = newVal
        if (this.selectedEmission && this.selectedEmission.manifest_type && !this.editOrderId) {
          this.refreshManifestTypes();
        }
        this.searchSalesItemPrices(newVal.id)
        this.searchEmissionDeliverersBy(newVal.id, this.selectedEmission.location?.id)
        this.searchEmissionRegistersBy(newVal.id, this.selectedEmission.location?.id)
      }
    },
    /*
     * 「売上計上しない」チェック履歴の保持
     * ①マスターから登録：売上計上しないはチェックOFF
     * ②フリー登録に画面遷移：システム固定で売上計上しないはチェックON
     * ③マスターから登録に画面遷移：①でチェックOFFだったのでチェックOFFで表示
     * もしも①でチェックONにしたら、③ではチェックONで表示される。
     */
    'order.not_recorded_sales': function () {
      if (this.order.form_type === 'master_mode') {
        if (this.order.not_recorded_sales) {
          this.notRecordedSalesByMasterMode = true
        } else {
          this.notRecordedSalesByMasterMode = false
        }
      }
    },
    'order.collected_date': function (newVal) {
      this.collectedDateChangeEvent(newVal)
    },
  },
  created() {

    this.fetchQuantityUnits().then((content) => {
      this.quantityUnits = content.quantity_units
    })
    this.fetchHazardousSubstances().then((content) => {
      this.hazardousSubstances = content.hazardous_substances
    })
    this.fetchQuantityConfirms().then((content) => {
      this.quantityConfirms = content.quantity_confirms
    })
    if (this.callableType === 'general') {
      /**
       * @param content { Object }
       * @property content.general_items { Array }
       */
      this.fetchGeneralItems().then((content) => {
        this.items = content.general_items
      })
    } else {
      this.fetchItems().then((content) => {
        this.items = content.items
      })
    }
    this.fetchPackings().then((content) => {
      this.packings = content.packings
    })

    this.fetchTransportations().then((content) => {
      this.transportations = content.transportations
    })
    /**
     * @param content { Object }
     * @property content.disposal_methods { Array }
     */
    this.fetchDisposalMethods().then((content) => {
      this.disposalMethods = content.disposal_methods
    })
    /**
     * @param content { Object }
     * @property content.sales_staffs { Array }
     */
    this.fetchSalesStaffs().then((content) => {
      this.salesStaffs = content.sales_staffs
    })

    this.fetchVoteStaffs({without_invisible: true}).then((content) => {
      this.voteStaffs = content.vote_staffs
    })

    this.fetchDrivers({without_invisible: true}).then((content) => { this.drivers = content.drivers })
    this.fetchVehicles({ registered_number: true}).then((content) => { this.vehicles = content.vehicles })

    /** 複写の場合 */
    if (this.duplicateOrderId) {
      this.fetchDuplicateOrder({id: this.duplicateOrderId}).then((content) => {
        this.stopLocationAutoSelect = true;
        this.order = content
        this.order.selected_collected_dates = this.order.selected_collected_dates || []
        this.selectedEmission = content.emission
        this.backupSelectedEmission = _.cloneDeep(content.emission);
        this.manifestTypes = content.manifest_types
        this.repeatSettings = content.repeat_settings
        this.order.manifest_type = this.callableType === 'general' ? 'general_form' : content.manifest_type
        if (this.callableType === 'general') {
          this.order.not_recorded_sales = true
        }
        this.refreshManifestTypes()
        this.reconfigureManifestType()
        if (this.$route.query.plan_date) {
          this.order.collected_date = this.$route.query.plan_date;
        }
        this.initValidateManifestTypeState(true)

        // マスタから登録で、スポットを利用しない場合は事業場情報を消す.
        if (this.order.form_type === 'master_mode' && !this.order.use_spot_emission_location) {
          this.order.emission_location_name = null;
          this.order.emission_location_zip_code = null;
          this.order.emission_location_prefecture_code = null;
          this.order.emission_location_address_1 = null;
          this.order.emission_location_address_2 = null;
          this.order.emission_location_address_3 = null;
          this.order.emission_location_phone_number = null;
          this.order.emission_location_memo = null;
        }

      })
    /** 登録パターン */
    } else if (this.entryPatternId) {

      /**
       * @param content { Object }
       * @property content.manifest_types { Array }
       * @property content.repeat_settings { Array }
       */
      this.fetchEditEntryPattern({ emission_id: this.entryPatternEmissionId, id: this.entryPatternId }).then((content) => {
        this.entryPatternForm = content.entry_pattern;
        this.order = content
        this.order.selected_collected_dates = this.order.selected_collected_dates || []
        this.selectedEmission = content.emission
        this.backupSelectedEmission = _.cloneDeep(content.emission);
        this.manifestTypes = content.manifest_types
        this.repeatSettings = content.repeat_settings
        // this.files = this.order.order_attachments
        this.order.manifest_type = this.callableType === 'general' ? 'general_form' : content.manifest_type
        if (this.callableType === 'general') {
          this.order.not_recorded_sales = true
        }
        this.refreshManifestTypes()
        this.reconfigureManifestType()
        this.initValidateManifestTypeState(true)

        this.isSharedCheckboxChangeEvent();

        // 登録パターン時に品目情報に基づいて運搬ルートを再取得
        // this.$nextTick(() => {
        //   this.fetchTransportRoutesForOrder()
        // })
      });
    /** 編集の場合 */
    } else if (this.editOrderId) {
      this.fetchEditOrder({id: this.editOrderId}).then((content) => {
        this.order = content
        // this.selectableSupplierIds = [ content.emission_id, content.emission_location_id ];
        this.order.selected_collected_dates = this.order.selected_collected_dates || []
        this.selectedEmission = content.emission
        this.backupSelectedEmission = _.cloneDeep(content.emission);
        this.manifestTypes = content.manifest_types
        this.repeatSettings = content.repeat_settings
        this.files = this.order.order_attachments
        this.order.manifest_type = this.callableType === 'general' ? 'general_form' : content.manifest_type
        if (this.callableType === 'general') {
          this.order.not_recorded_sales = true
        }
        this.refreshManifestTypes()
        this.reconfigureManifestType()
        this.initValidateManifestTypeState(true)

        // 編集時に品目情報に基づいて運搬ルートを再取得
        // this.$nextTick(() => {
        //   this.fetchTransportRoutesForOrder()
        // })
      })

    /** 新規の場合 */
    } else {
      this.fetchNewOrder().then((content) => {
        this.order = content
        this.order.selected_collected_dates = []
        this.manifestTypes = content.manifest_types
        this.repeatSettings = content.repeat_settings
        this.order.form_type = 'master_mode'
        // callableTypeがgeneralの場合はmanifest_typeをgeneral_formに設定
        if (this.callableType === 'general') {
          this.order.manifest_type = 'general_form'
          this.order.not_recorded_sales = true
        }
        // ドライバースケジュールからであれば設定値を反映
        if (this.loadBy === 'driver_schedule') {
          this.order.collected_date = this.driverScheduleTargetDate
          this.order.transport_user_id = this.driverScheduleTransportUserId
          this.order.transport_user_name = this.driverScheduleTransportUserName
        } else {
          if (this.$route.query.plan_date) {
            this.order.collected_date = this.$route.query.plan_date;
          }
        }

        this.refreshManifestTypes()
        this.reconfigureManifestType()

        this.$nextTick(() => {
          this.$refs.emission.focusToSupplier();
        })

      })
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('snackbar', {
      showInfo: 'showInfo',
    }),
    ...mapActions('DriverOrderAcceptCollection', {
      fetchNewOrder: 'new',
      fetchDuplicateOrder: 'duplicate',
      fetchEditOrder: 'edit',
      createOrder: 'create',
      updateOrder: 'update',
      deleteCollection: 'delete',
    }),
    ...mapActions('DriverOrderAcceptPickup', {
      deletePickup: 'delete'
    }),
    ...mapActions('DriverOrderAcceptCarryIn', {
      deleteCarryIn: 'delete',
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'index',
    }),
    ...mapActions('DriverMasterSearchVehicle', {
      fetchVehicles: 'search',
    }),
    ...mapActions('DriverMasterSearchSalesStaff', {
      fetchSalesStaffs: 'index',
    }),
    ...mapActions('DriverOrderAcceptCollectionProvisional', {
      createProvisionalOrder: 'create',
      updateProvisionalOrder: 'update',
    }),
    ...mapActions('DriverMasterSearchSupplierSalesItemPriceDetail', {
      fetchSalesItemPrices: 'index_with_reference_date'
    }),
    ...mapActions('DriverMasterSearchEmissionDeliverer', {
      fetchDeliverers: 'index',
    }),
    ...mapActions('DriverMasterSearchEmissionRegister', {
      fetchRegisters: 'index'
    }),
    ...mapActions('DriverMasterSearchQuantityConfirm', {
      fetchQuantityConfirms: ('index')
    }),
    ...mapActions('DriverMasterSearchHazardousSubstance', {
      fetchHazardousSubstances: 'index'
    }),
    ...mapActions('DriverMasterSearchQuantityUnit', {
      fetchQuantityUnits: 'index'
    }),
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'index'
    }),
    ...mapActions('DriverMasterSearchGeneralItem', {
      fetchGeneralItems: 'index'
    }),
    ...mapActions('DriverMasterSearchPacking', {
      fetchPackings: 'index'
    }),
    // ...mapActions('DriverMasterSearchTransportRoute', {
    //   fetchTransportRoutes: 'search'
    // }),
    ...mapActions('DriverMasterSearchTransportation', {
      fetchTransportations: 'index'
    }),
    ...mapActions('DriverMasterSearchDisposalMethod', {
      fetchDisposalMethods: 'index',
    }),
    ...mapActions('DriverMasterSearchVoteStaff', {
      fetchVoteStaffs: 'index',
    }),
    ...mapActions('snackbar', {
      showError: 'showError',
    }),
    ...mapActions('DriverOrderSelfEmissionReservation', {
      selfEmissionReservation: 'update'
    }),
    ...mapActions("DriverOrdersCollectionVerifyOrderManifest", {
      verifyOrderManifest: "update"
    }),
    ...mapActions('DriverOrdersAcceptManifest', {
      fetchNewManifest: 'new'
    }),
    ...mapActions("DriverMasterSearchEmissionDetail", {
      fetchEmissionDetail: "show",
    }),
    ...mapActions("DriverMasterEntryPattern", {
      fetchEntryPatterns: 'index',
      fetchEntryPattern: 'show',
    }),
    ...mapActions("DriverMasterEmissionEntryPattern", {
      fetchEditEntryPattern: "edit",
      updateEntryPattern: "update"
    }),

    /* イベントアクション <-----  */
    /**
     * 更新履歴ボタン クリックイベント
     */
    showUpdateHistoriesButtonClickEvent () {
      this.showUpdateHistoryDialog = true
    },
    /**
     * 動作(マスタ・フリー)モード クリックイベント
     */
    formTypeButtonClickEvent (form_type) {
      this.order.form_type = form_type

      // フリー登録モードの場合
      if (form_type === 'free_mode') {
        this.order.not_recorded_sales = true
        // マスター登録モードの場合
      } else {
        this.order.not_recorded_sales = this.notRecordedSalesByMasterMode
      }
      this.refreshManifestTypes()
      this.reconfigureManifestType();
    },
    /**
     * スポット事業場入力のペンマークボタン押下
     */
    editSpotLocationButtonClickEvent () {
      this.spotLocation = null;
      this.spotLocation = {
        name: this.order.emission_location_name,
        zip_code: this.order.emission_location_zip_code,
        prefecture_code: this.order.emission_location_prefecture_code,
        address_1: this.order.emission_location_address_1,
        address_2: this.order.emission_location_address_2,
        address_3: this.order.emission_location_address_3,
        phone_number: this.order.emission_location_phone_number,
        memo: this.order.emission_location_memo
      }
      this.enableEditSpotLocation = true
    },
    /**
     * フリー登録 排出事業者
     * 「住所→郵便番号」ボタン クリックイベント
     */
    searchFreeEmissionZipButtonClickEvent () {
      this.enableSearchFreeEmissionZipModal = true;
    },
    /**
     * フリー登録 排出事業場
     * 「住所→郵便番号」ボタン クリックイベント
     */
    searchFreeEmissionLocationZipButtonClickEvent () {
      this.enableSearchFreeEmissionLocationZipModal = true;
    },
    /**
     * 排出事業者情報を事業場にコピーするボタンクリックイベント
     */
    copyEmissionToEmissionLocationButtonClickEvent()  {
      this.order.emission_location_name = this.order.emission_name
      this.order.emission_location_zip_code = this.order.emission_zip_code
      this.order.emission_location_prefecture_code = this.order.emission_prefecture_code
      this.order.emission_location_address_1 = this.order.emission_address_1
      this.order.emission_location_address_2 = this.order.emission_address_2
      this.order.emission_location_address_3 = this.order.emission_address_3
      this.order.emission_location_phone_number = this.order.emission_phone_number
    },
    /**
     * 運搬担当者クリア クリックイベント
     */
    transportUserClearClickEvent () {
      this.order.transport_user_id = null
      this.order.transport_user_name = null
    },
    /**
     * 排出事業者を検索ボタン クリックイベント
     */
    searchEmissionButtonClickEvent () {
      this.enableSearchEmissionDialog = true
    },
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.previousControl()
    },
    /**
     * 受注登録ボタン クリックイベント
     * ※ ドライバースケジュールの受注登録ボタンのクリックイベント内で本メソッドを直接コールしています。
     */
    registerOrderButtonClickEvent () {
      this.emissionApproval = false
      let $self = this
      $self.$emit('loadingCallback', true)

      // 安全装置：5秒後に強制的にローディングを解除
      const safetyTimeout = setTimeout(() => {
        $self.$emit('loadingCallback', false)
      }, 5000)

      if (!this.beforeSaveValidateManifestTypeState()) {
        this.reloadKey = this.reloadKey + 1
        return false;
      }

      return new Promise((resolve) => {
        setTimeout(() => {
          this.$refs.acceptCollectionFormValidator.validateWithInfo().then(({ isValid, errors }) => {
            if (isValid) {
              if (this.loadBy === 'driver_schedule') {
                // 受注以外(ドライバースケジュール)からの場合は即時登録
                $self.saveCollection(null);
              } else {
                // 受注からの場合は登録前のダイアログを表示
                $self.enableRegistrationProvisionalDialog = true
                // ダイアログ表示時はローディングを解除
                clearTimeout(safetyTimeout)
                $self.$emit('loadingCallback', false)
              }
            } else {
              let messages = []
              for (let key in errors) {
                if (errors[key].length > 0) {
                  messages.push(errors[key][0])
                }
              }
              this.showError({ message: messages.join(',') })
              clearTimeout(safetyTimeout)
              $self.$emit('loadingCallback', false)
            }
          }).catch((error) => {
            // バリデーション処理でエラーが発生した場合
            console.error('Validation error:', error)
            clearTimeout(safetyTimeout)
            $self.$emit('loadingCallback', false)
          })
          resolve();
        }, 1000);
      });
    },
    /**
     * 排出者申請ボタン クリックイベント
     */
    registerApprovalButtonClickEvent () {
      this.manifestTypeCheck ()
      this.emissionApproval = true

      if (!this.beforeSaveValidateManifestTypeState()) {
        this.reloadKey = this.reloadKey + 1
        return false;
      }

      return new Promise((resolve) => {
        setTimeout(() => {
          let $self = this
          this.$refs.acceptCollectionFormValidator.validateWithInfo().then(({ isValid, errors }) => {
            if (isValid) {
              $self.enableRegistrationProvisionalDialog = true
            } else {
              let messages = []
              for (let key in errors) {
                if (errors[key].length > 0) {
                  messages.push(errors[key][0])
                }
              }
              this.showError({ message: messages.join(',') })
            }
          })
          resolve();
        }, 1000);
      });
    },
    /**
     * 再申請ボタン クリックイベント
     */
    approvalOrderButtonClickEvent () {
      this.emissionApproval = false

      if (!this.beforeSaveValidateManifestTypeState()) {
        this.reloadKey = this.reloadKey + 1
        return false;
      }

      return new Promise((resolve) => {
        setTimeout(() => {
          let $self = this
          this.$refs.acceptCollectionFormValidator.validateWithInfo().then(({ isValid, errors }) => {
            if (isValid) {
              this.targetOrderId = this.order.id
              $self.enableMailApprovalDialog = true
            } else {
              let messages = []
              for (let key in errors) {
                if (errors[key].length > 0) {
                  messages.push(errors[key][0])
                }
              }
              this.showError({ message: messages.join(',') })
            }
          })
          resolve();
        }, 1000);
      });
    },
    /**
     * 仮保存ボタン クリックイベント
     */
    temporarySaveButtonClickEvent () {
      const $self = this;

      if (!this.beforeSaveValidateManifestTypeState()) {
        this.reloadKey = this.reloadKey + 1
        return false;
      }

      return new Promise((resolve) => {
        setTimeout(() => {
          this.$refs.acceptCollectionFormValidator.validateWithInfo().then(({ isValid, errors }) => {
            if (isValid) {
              const params = this.buildParam(true)
              if (this.editOrderId) {
                $self.updateProvisionalOrder({id: this.editOrderId, params: params}).then(() => {
                  $self.$router.push( { name: 'DriverOrderAccepts' } )
                })
              } else {
                $self.createProvisionalOrder({params: params}).then(() => {
                  $self.$router.push( { name: 'DriverOrderAccepts' } )
                })
              }
            } else {
              let messages = []
              for (let key in errors) {
                if (errors[key].length > 0) {
                  messages.push(errors[key][0])
                }
              }
              this.showError({ message: messages.join(',') })
            }
          })
          resolve();
        }, 1000);
      });
    },
    /**
     * 排出持込
     * 予約登録ボタン クリックイベント
     * 確認用のダイアログを表示する.
     */
    selfEmissionReservationButtonClickEvent () {

      if (!this.beforeSaveValidateManifestTypeState()) {
        this.reloadKey = this.reloadKey + 1
        return false;
      }

      return new Promise((resolve) => {
        setTimeout(() => {
          this.$refs.acceptCollectionFormValidator.validateWithInfo().then(({ isValid, errors }) => {
            if (isValid) {
              const params = this.buildParam(false)
              this.selfEmissionReservation({id: this.editOrderId, params: params}).then(() => {
                this.$router.push( { name: 'DriverOrderAccepts' } )
              })
            } else {
              let messages = []
              for (let key in errors) {
                if (errors[key].length > 0) {
                  messages.push(errors[key][0])
                }
              }
              this.showError({ message: messages.join(',') })
            }
          })
          resolve();
        }, 1000);
      });
    },
    /**
     * 引渡日 チェンジイベント
     * 「過去マニフェストの起票」チェックボックスの制御を行う
     * @param item
     */
    collectedDateChangeEvent(item) {
      const now = this.$dayjs(this.$dayjs().format("YYYY-MM-DD"))
      const date = this.$dayjs(item)
      this.order.past_manifest = date.isBefore(now);
    },
    /**
     * スポット排出事業場 チェンジイベント
     */
    spotEmissionLocationChangeEvent () {
      let emissionLocationId = null;
      if (this.order.use_spot_emission_location) {
        this.order.emission_location_id = null;
        this.order.emission_location_code = null;
        this.selectedEmission.location = null;
      } else {

        if (this.backupSelectedEmission.location.id) {
          this.selectedEmission.location = {
            id: this.backupSelectedEmission.location.id,
            code: this.backupSelectedEmission.location.code,
            name: this.backupSelectedEmission.location.name,
            zip_code: this.backupSelectedEmission.location.zip_code,
            prefecture_code: this.backupSelectedEmission.location.prefecture_code,
            address: this.backupSelectedEmission.location.address,
            phone_number: this.backupSelectedEmission.location.phone_number,
            memo: this.backupSelectedEmission.location.memo
          }
          this.order.emission_location_id = this.backupSelectedEmission.location.id;
          this.order.emission_location_code = this.backupSelectedEmission.location.code;
          this.entryPatternForm.location_id = this.backupSelectedEmission.location.id;
          this.entryPatternForm.location_name = this.backupSelectedEmission.location.name;
        } else {
          this.selectedEmission.location = {}
          this.entryPatternForm.location_id = null;
          this.entryPatternForm.location_name = null;
        }

        this.entryPatternForm.is_shared = false;
        emissionLocationId = this.backupSelectedEmission.location.id;
      }
      this.searchEmissionDeliverersBy(this.selectedEmission.id, emissionLocationId)
      this.searchEmissionRegistersBy(this.selectedEmission.id, emissionLocationId)
    },
    /**
     * 運搬担当者 チェンジイベント
     */
    transportUserChangeEvent (item) {
      const transportUser = this.drivers.find( (v) => v.text.replace(/\s+/g,'') === item.replace(/\s+/g,''))
      if (transportUser) {
        this.order.transport_user_id = transportUser.value
      } else {
        this.order.transport_user_id = null
      }
    },
    /**
     * 過去マニフェストの起票 チェンジイベント
     */
    pastManifestChangeEvent () {
      if (!this.order.past_manifest) {
        this.order.collected_date = null
      }
    },
    /**
     * 事業場共通として利用する チェンジイベント
     */
    isSharedCheckboxChangeEvent() {

      /**
       * 共通で利用
       */
      if (this.entryPatternForm.is_shared) {

        this.order.emission_location_id = null;
        this.order.use_spot_emission_location = false;
        this.entryPatternForm.location_id = null;
        this.entryPatternForm.location_name = null;

        if (this.selectedEmission) {
          this.selectedEmission.location = null;
        }
        if (this.backupSelectedEmission) {
          this.backupSelectedEmission.location = null;
        }
      }
    },


    /* イベントアクション -----> */
    /* コールバック <----- */

    closeUpdateHistoryModal () {
      this.showUpdateHistoryDialog = false
    },
    /**
     * スポット事業場モーダル コールバック
     */
    spotLocationCancelCallback () {
      this.enableEditSpotLocation = false;
    },
    /**
     * 回収日 コールバック
     * @param date
     */
    dateChangedCallback (date) {
      this.order.collected_date = date;
    },
    /**
     * スポット事業場モーダル コールバック
     */
    spotLocationRegisterCallback (location) {
      this.order.spot_input_completed = true;
      this.order.emission_location_id = null;
      this.order.emission_location_code = null;
      this.selectedEmission.location = {
        name: location.name,
        zip_code: location.zip_code,
        address: location.address,
        phone_number: location.phone_number,
        memo: location.memo
      }

      this.order.emission_location_name = location.name;
      this.order.emission_location_zip_code = location.zip_code;
      this.order.emission_location_prefecture_code = location.prefecture_code;
      this.order.emission_location_address_1 = location.address_1;
      this.order.emission_location_address_2 = location.address_2;
      this.order.emission_location_address_3 = location.address_3;
      this.order.emission_location_phone_number = location.phone_number;
      this.order.emission_location_memo = location.memo;

      this.entryPatternForm.location_id = null;
      this.entryPatternForm.location_name = location.name;


      this.spotLocationCancelCallback();
    },
    /**
     * フリー登録 排出事業者
     * 「住所→郵便番号」ボタン コールバック
     * @param address { object } 住所情報
     * @param address { object } 住所情報
     * @property address.zip_code { string } 郵便番号
     * @property address.prefecture_code { string } 都道府県コード
     * @property address.city { string } 市区町村
     * @property address.town { string } 町域
     */
    reflectFreeEmissionFullCallback (address) {
      this.order.emission_zip_code = address.zip_code;
      this.order.emission_prefecture_code = `${address.prefecture_code}`;
      this.order.emission_address_1 = address.city ? address.city : '';
      this.order.emission_address_2 = address.town ? address.town : '';
    },
    /**
     * フリー登録 排出事業者
     * 「住所→郵便番号」ボタン コールバック
     * @param zipCode { string } 郵便番号
     */
    reflectFreeEmissionZipCallback (zipCode) {
      this.order.emission_zip_code = zipCode
    },
    /**
     * フリー登録 排出事業場
     * 「住所→郵便番号」ボタン コールバック
     * @param address { object } 住所情報
     * @property address.zip_code { string } 郵便番号
     * @property address.prefecture_code { string } 都道府県コード
     * @property address.city { string } 市区町村
     * @property address.town { string } 町域
     */
    reflectFreeEmissionLocationFullCallback (address) {
      this.order.emission_location_zip_code = address.zip_code;
      this.order.emission_location_prefecture_code = `${address.prefecture_code}`;
      this.order.emission_location_address_1 = address.city ? address.city : '';
      this.order.emission_location_address_2 = address.town ? address.town : '';
    },
    /**
     * フリー登録 排出事業場
     * 「住所→郵便番号」ボタン コールバック
     * @param zipCode { string } 郵便番号
     */
    reflectFreeEmissionLocationZipCallback (zipCode) {
      this.order.emission_location_zip_code = zipCode
    },

    /**
     * 再申請ポップアップ(保存ボタン)で送信を押下
     */
    dialogRegisterCallBack(move_to_transaction) {
      this.sendSave = true
      this.enableMailApprovalDialog = false
      this.saveCollection(move_to_transaction)
    },
    /**
     * 直近の回収履歴 反映コールバック
     * @param item
     */
    reflectHistoryCallback (item) {
      this.retentionOrder = item;
      this.stopLocationAutoSelect = true;
      this.order.emission_id = item.emission_id;
      this.order.emission_location_id = item.emission_location_id;
      this.reflectionOrder('history');
    },
    /**
     * 登録パターン 反映
     * @param item { Object } 受注情報
     */
    reflectPatternCallback (item) {
      this.retentionOrder = item;
      this.reflectionOrder('pattern');
    },

    /**
     * 品目の追加ボタン コールバック
     */
    addManifestCallback () {
      this.fetchNewManifest().then((content) => {
        let manifest = content;
        manifest.manifest_type = this.order.manifest_type;

        this.order.manifests.push(manifest)

        this.$nextTick(() => {
          this.$refs.salesItemBlock.switchToNewTab();
        })
      })
    },
    /**
     * 品目コールバック
     * @param manifest { Object } 変更されたマニフェスト
     */
    changeManifestTypeCallback(manifest) {
      // 品目が変更された場合、その品目に応じた運搬ルートを再取得
      this.reconfigureManifestType();
      this.refreshManifestTypes();
    },
    /**
     * 登録モーダルからの戻り
     * @param afterTransaction { Boolean }　true: 売上入力へ, false: 一覧へ
     */
    registrationProvisionalRegisterCallback (afterTransaction) {
      if (this.editOrderId) {
        const params = this.buildParam(false)
        this.targetOrderId = this.order.id
        this.afterSaveMove = afterTransaction
        this.mustSave = true
        this.verifyOrderManifest({ order_id: this.editOrderId, params: params }).then((content) => {
          if (content.changed) {
            this.enableMailConfirmableDialog = true;
          } else {
            this.$emit('loadingCallback', true)
            this.saveCollection(afterTransaction);
          }
        })
      } else {
        this.saveCollection(afterTransaction);
      }
    },
    /**
     * 回収先（排出事業者・事業場） チェンジコールバック
     *
     * @param emission_id { Number } 排出事業者ID
     * @param location_id { Number } 排出事業場ID
     * @param location_code { String } 排出事業場コード
     */
    supplierChangeCallback (emission_id, location_id, location_code) {

      const backup_supplier_id = this.order.emission_id;
      const backup_location_id = this.order.emission_location_id;
      const backup_location_code = this.order.emission_location_code;

      this.order.emission_id = emission_id;
      if (emission_id !== backup_supplier_id) {
        this.order.use_spot_emission_location = false;
      }

      this.order.emission_location_id = location_id;
      this.order.emission_location_code = location_code;

      if (location_id === null) {
        this.entryPatternForm.location_id = null;
        this.entryPatternForm.location_name = null;
      }

      if (backup_location_id === location_id && backup_location_code && location_code === null) {
        this.order.emission_location_code = backup_location_code;
      }

      if (!this.order.use_spot_emission_location && (emission_id !== backup_supplier_id || backup_location_id !== location_id)) {
        this.$nextTick(() => {
          this.loadSupplierDetail();
        })
      }
    },
    /**
     * 排出事業者を検索モーダル コールバック
     * ここでidの書き換えを行ってしまうので、supplierIdChangedCallback, supplierLocationChangedCallbackで変更を検知できないため
     * 詳細情報の取得・デフォルトの反映はここで行う.
     * @param emissionDetail { Object }
     */
    reflectEmissionCallback(emissionDetail) {
      this.order.emission_id = emissionDetail.id;
      this.order.emission_location_id = emissionDetail.location.id;
      this.order.emission_location_code = emissionDetail.location.code;
      this.order.use_spot_emission_location = false;

      this.loadSupplierDetail();
      this.searchEmissionDialogCancelCallback();
    },
    registerPatternCallback () {
      this.reloadEntryPatternKey += 1;
    },
    registrationProvisionalDialogCloseCallback () {
      this.enableRegistrationProvisionalDialog = false
    },
    searchEmissionDialogCancelCallback () {
      this.enableSearchEmissionDialog = false
    },

    /**
     * 再申請ポップアップで閉じるを押下
     */
    closeDialogCallback() {
      this.sendSave = false
      this.enableMailApprovalDialog = false
      this.enableMailConfirmableDialog = false;
      this.enableRegistrationProvisionalDialog = false;
    },
    closeModalCallback () {
      this.enableSearchFreeEmissionZipModal = false;
      this.enableSearchFreeEmissionLocationZipModal = false;
    },

    /* コールバック -----> */
    /* メソッド <----- */
    /**
     * 登録パターン更新
     * 排出事業者詳細より直接コール
     */
    registerEntryPattern () {

      /**
       * @param errors { Object }
       * @property errors.entry_pattern_name { Array } パターン名 エラー内容
       * @property errors.sort_priority { Array } 並び順 エラー内容
       */
      this.$refs.acceptCollectionFormValidator.validateWithInfo().then(({ isValid, errors }) => {

        const entryPatternErrorCounts = errors.entry_pattern_name.length;
        const sortPriorityErrorCounts = errors.sort_priority.length;
        const emissionLocationErrorCounts = errors.emission_location_id.length;

        if (entryPatternErrorCounts <= 0 && sortPriorityErrorCounts <= 0 && emissionLocationErrorCounts <= 0) {

          const orderMember = this.entryPatternParameterBuilder(this.callableType, this.entryPatternForm.is_shared);
          const patternForm = {
            name: this.entryPatternForm.name,
            location_id: this.entryPatternForm.is_shared ? null : this.entryPatternForm.location_id,
            is_primary: this.entryPatternForm.is_primary,
            use_collection_date_offset: this.entryPatternForm.use_collection_date_offset,
            collection_date_offset_days: this.entryPatternForm.collection_date_offset_days || 0,
            // standard_quantity_type: this.entryPatternForm.standard_quantity_type,
            // recycle_disposer_disposal_method: this.entryPatternForm.recycle_disposer_disposal_method,
            sort_priority: this.entryPatternForm.sort_priority,
          }
          const parameters = {
            ...patternForm,
            ...orderMember,
            order_type: this.order.order_type,
          };

          this.updateEntryPattern({ emission_id: this.entryPatternEmissionId, id: this.entryPatternId, params: parameters }).then(() => {
            this.$emit("registerCallback")
          })
        }
      });
    },

    /**
     * 受注情報を反映する
     * 直近の回収履歴, 登録パターンで呼出
     */
    reflectionOrder (source = null) {

      let excludeKeys = [
        'id',
        'order_collection_id',
        'manifests',
        'order_attachments',
        'collected_date',
        'past_manifest'
      ]

      /**
       * 登録パターンで事業場共通の場合は事業場情報の上書きは行わない。
       * @param retentionOrder { Object }
       * @property retentionOrder.entry_pattern { Object } 登録パターン
       * @property retentionOrder.entry_pattern.is_shared { Boolean } 事業場共通
       */
      const isSharedEntryPattern = (this.retentionOrder?.entry_pattern && this.retentionOrder.entry_pattern.is_shared) || false;
      if (isSharedEntryPattern) {
        const sharedExcludeKeys =[
          'emission_location_id',
          'emission_location_code',
          'emission',
          'emission_location_name',
          'emission_location_zip_code',
          'emission_location_prefecture_code',
          'emission_location_address_1',
          'emission_location_address_2',
          'emission_location_address_3',
          'emission_location_phone_number',
          'emission_location_memo',
          'use_spot_emission_location',
          'spot_input_changed',
        ]
        excludeKeys = excludeKeys.concat(sharedExcludeKeys);
      }

      // 排出事業場設定済の場合は、事業場情報をクリア
      if(!isSharedEntryPattern && this.retentionOrder.emission_location_id) {
        const sharedExcludeKeys =[
          'emission',
          'emission_location_name',
          'emission_location_zip_code',
          'emission_location_prefecture_code',
          'emission_location_address_1',
          'emission_location_address_2',
          'emission_location_address_3',
          'emission_location_phone_number',
          'emission_location_memo',
        ]
        excludeKeys = excludeKeys.concat(sharedExcludeKeys);
      }


      for (const key in this.retentionOrder) {
        if (!excludeKeys.includes(key)) {
          this.order[key] = this.retentionOrder[key]
        }
      }

      this.order.spot_input_completed = this.order.use_spot_emission_location

      const manifestNumbers = [];
      for (const manifest of this.order.manifests) {
        if (manifest.manifest_no) {
          manifestNumbers.push(manifest.manifest_no);
        }
        manifest._destroy = true;
      }

      // スポットでなく、事業場選択の場合は、事業場情報を反映しない


      for (let i = 0; i < this.retentionOrder.manifests.length; i++) {
        let manifest = this.retentionOrder.manifests[i];
        if (manifestNumbers[i]) {
          manifest.manifest_no = manifestNumbers[i];
        }
        this.order.manifests.push(manifest)
      }

      /*
       * 登録パターンで事業場共通の場合は事業場情報の上書きは行わない。
       */
      if (!isSharedEntryPattern) {
        this.selectedEmission = this.retentionOrder.emission
        this.backupSelectedEmission = {};
        Object.assign(this.backupSelectedEmission, this.retentionOrder.emission)
      }

      if (!this.entryPatternId) {
        const sourceMessages = {
          history: '直近の回収履歴を反映しました',
          pattern: '登録パターンを反映しました'
        }
        const message = sourceMessages[source]
        this.showInfo({message});
      }
      this.retentionOrder = null;

      // 反映後に品目情報に基づいて運搬ルートを再取得
      this.$nextTick(() => {
        // this.fetchTransportRoutesForOrder().finally(() => {
          // 複数品目がある場合に先頭タブを選択
        if (this.$refs.salesItemBlock) {
          this.$refs.salesItemBlock.selectedTab = 0
        }
        // })
      })

    },
    /**
     * ファイル種別が画像であるかの判定
     * @param type
     * @return { boolean }
     */
    isImageContent (type) {
      return type.startsWith('image')
    },
    /**
     * ファイル種別がPDFであるかの判定
     * @param type
     * @return { boolean }
     */
    isPdfContent (type) {
      return type.endsWith('pdf')
    },
    documentIcon(type) {
      return (this.isPdfContent(type)) ? "mdi-file-pdf-box" : "mdi-file-document-outline"
    },
    removeFile (file) {
      if (!file) return
      file._destroy = true
    },
    isEmpty (val) {
      return (val === null || val === '')
    },
    /**
     * 複写ロード時のチェック処理
     * @param initialLoad { boolean } 初回ロード: true
     * @return { boolean }
     */
    initValidateManifestTypeState (initialLoad = false) {
      const orderManifestType = this.order.manifest_type;
      const emissionManifestType= this.selectedEmission.manifest_type;
      let hasNonSubscribeTrader = false;

      /**
       * 初回ロード時はレスポンスに含まれる値から取得
       */
      if (initialLoad) {
        hasNonSubscribeTrader = this.order.manifests.find((manifest) => manifest.effective_transport_route_include_non_subscribe_trader)
      } else {
        /**
         * 登録時は登録内容から
         */
        for (const manifest of this.order.manifests) {
          const transport_route = this.transportRoutes.find((route) => route.id === manifest.transport_route_id)
          if (transport_route && transport_route?.include_non_subscribe_trader) {
            hasNonSubscribeTrader = true;
            break;
          }
        }
      }

      this.manifestTypeMismatchMessage = "現在の排出事業者のマスタ区分と発行するマニフェストの区分が異なります。<br />" +
        "発行するマニフェストの区分を排出事業者のマスタ区分に合わせたい場合は、ルートを再選択して現在のマニフェスト区分を読み込んでください。"

      if (emissionManifestType === 'dxe_form' && !hasNonSubscribeTrader && ['other_form', 'paper_form'].includes(orderManifestType)) {
        /**
         * ・排出事業者がEDIで、ルートがEDIだが、マニフェスト区分がWeb・紙の場合はポップアップ表示する（10秒）。
         */
        this.manifestTypeMismatchAlert = true;

      } else if (emissionManifestType === 'other_form' && !hasNonSubscribeTrader && ['paper_form'].includes(orderManifestType)) {
        /**
         * ・排出事業者がWebで、ルートが未加入業者を含まないルートの場合、マニフェスト区分が紙の場合は、ポップアップ表示する（10秒）。
         */
        this.manifestTypeMismatchAlert = true;

      } else if (emissionManifestType === 'paper_form' && orderManifestType === 'other_form') {
        /**
         * ・排出事業者が紙だが、マニフェスト区分がWebの場合は、ポップアップ表示する（10秒）。
         */
        this.manifestTypeMismatchAlert = true;
      }

      if (this.manifestTypeMismatchAlert) {
        setTimeout(() => { this.manifestTypeMismatchAlert = false}, 20000)
      }

      return !this.manifestTypeMismatchAlert;
    },
    /**
     * 保存時のチェック処理
     * @return { boolean }
     */
    beforeSaveValidateManifestTypeState () {

      this.manifestTypeMismatchAlert = false

      const orderManifestType = this.order?.manifest_type;
      const emissionManifestType = this.selectedEmission?.manifest_type;

      this.manifestTypeMismatchMessage = "利用出来ないマニフェスト区分が選択されています<br />（ルートを再選択して現在のマニフェスト区分を読み込んでください）"

      /**
       * 保存時エラー対応
       * ・排出事業者がWebだが、マニフェスト区分がEDIの場合は、保存時エラー。
       * ・排出事業者が紙だが、マニフェスト区分がEDIの場合は、保存時エラー。
       */
      if (['other_form', 'paper_form'].includes(emissionManifestType) && orderManifestType === 'dxe_form') {

        this.manifestTypeMismatchAlert = true;
      }

      if (this.manifestTypeMismatchAlert) {
        setTimeout(() => { this.manifestTypeMismatchAlert = false}, 20000)
      }

      return !this.manifestTypeMismatchAlert;
    },

    /**
     * 取引先品目単価の取得
     * @param emission_id { Number } 排出事業者ID
     */
    searchSalesItemPrices(emission_id) {
      /**
       * @typedef content { Object }
       * @property emission_locations { Array }
       */
      const systemTime = this.$dayjs().format("YYYY-MM-DD");
      this.fetchSalesItemPrices( { id: emission_id, type: 'Emission', only_jwnet_item: true, reference_date: systemTime }).then((content) => {
        this.salesItemPrices = content.sales_item_price_details
        this._refreshManifestSalesItemPrices(content.sales_item_price_details)
      })
    },
    /**
     * 取引先品目単価の取得時にコールする.
     * @param { Object[] } itemPrices - 品目単価
     * @param { string } itemPrices[].code - コード
     * @private
     */
    _refreshManifestSalesItemPrices (itemPrices) {
      // コードだけ抽出
      const codes = itemPrices.map(v => v.code)
      for (const manifest of this.order.manifests) {
        if (!codes.includes(manifest.sales_item_price_code)) {
          manifest.sales_item_price_code = null
        }
      }
    },
    /**
     * 引渡担当者リストの取得
     * @param emission_id
     * @param emission_location_id
     */
    searchEmissionDeliverersBy( emission_id, emission_location_id ) {
      this.fetchDeliverers({ id: emission_id, emission_location_id: emission_location_id }).then((content) => {
        this.emissionDeliverers = content.deliverers
      })
    },
    /**
     * 登録担当者リストの取得
     * @param emission_id
     * @param emission_location_id
     */
    searchEmissionRegistersBy ( emission_id, emission_location_id ) {
      this.fetchRegisters( { id: emission_id, emission_location_id: emission_location_id }).then((content) => {
        this.emissionRegisters = content.registers
      })
    },

    set_unuse_repeat () {
      this.order.repeat_setting = 'unuse_repeat'
      this.order.copy_count = null
      this.order.selected_collected_dates = []
      this.selected_collected_dates_display = ''
    },
    setEmissionZipAddress (content) {
      this.order.emission_prefecture_code = `${content.pref_code}`
      this.order.emission_address_1 = `${content.locality}`
      this.order.emission_address_2 = `${content.street}`
    },
    setEmissionLocationZipAddress(content) {
      this.order.emission_location_prefecture_code = `${content.pref_code}`
      this.order.emission_location_address_1 = `${content.locality}`
      this.order.emission_location_address_2 = `${content.street}`
    },

    /**
     * マニ区分の再表示
     */
    refreshManifestTypes () {

      if (this.callableType === 'general') {
        return
      }

      if (this.manifestTypes) {
        if (this.order.form_type === 'master_mode') {
          this.dispManifestTypes = this.manifestTypes
        } else {
          // フリーモードに切り替え
          this.dispManifestTypes = this.manifestTypes.filter(v => v.value !== 'dxe_form')
        }
      }
    },
    /**
     * 画面上のマニフェスト種別のチェック
     */
    manifestTypeCheck () {

      /* 受注詳細 */
      this.order.manifests.forEach((manifest, index) => {

        this.includingPaper = false
        if (!manifest.already_registered) {

          /* マニフェスト区分 */
          let active_manifest_type = this.nullToBlank(manifest.manifest_type)
          if (active_manifest_type === 'paper_form') {
            this.includingPaper = true
          }
        }
      })
    },
    /**
     * マニフェスト区分変更通知
     */
    selectManifestType(previously_manifest_type) {
      if ((this.order.form_type === 'free_mode') || (this.order.form_type === 'master_mode' && this.selectedEmission !== null)) {
        if (this.order.manifest_type !== previously_manifest_type) {
          const manifestType = this.manifestTypes.find( (v) => v.value === this.order.manifest_type)?.text;
          this.showInfo({message: `マニフェスト区分が ${manifestType} に変更されました`});
        }
      }
    },
    /**
     * マニフェスト区分の設定
     * 以下を材料としてマニフェスト区分を決定する.
     * ・呼び出し種別(props.callerType)
     * ・動作モード(order.form_type)
     * ・排出事業者のマニフェスト区分(selectedEmission.manifest_type)
     * ・各品目(マニフェスト)の運搬ルート(order.manifests.include_non_subscribe_trader)
     */
    reconfigureManifestType () {
      const currentManifestType = this.order.manifest_type;
      let alternationManifestType = null;


      // 呼び出し種別が「general: 一般」
      if (this.callableType === 'general') {
        alternationManifestType = 'general_form';
      } else {
        // 品目で指定されている運搬ルートに「未加入」が含まれている
        const isIncludedNoneSubScribeTrader = this.order.manifests.find(v => !v._destroy && v.include_non_subscribe_trader)
        if (isIncludedNoneSubScribeTrader) {
          alternationManifestType = 'paper_form';
        } else if (this.order.form_type === 'free_mode') {
          alternationManifestType = this.dispManifestTypes[0].value;
        } else {
          alternationManifestType = this.selectedEmission?.manifest_type || this.dispManifestTypes[0].value;
        }
      }

      // 確定したマニフェスト区分をオーダー、マニフェストに設定
      this.order.manifest_type = alternationManifestType;
      for (const manifest of this.order.manifests) {
        // 各マニフェストのマニフェスト区分がEDIならばWebに変更
        manifest.manifest_type = alternationManifestType;
      }
      // console.log(`マニフェスト種別は「${currentManifestType}」から「${alternationManifestType}」に変更`)
      this.selectManifestType(currentManifestType)
    },
    /**
     * 選択した排出事業者・事業場の詳細情報を取得.
     */
    loadSupplierDetail () {
      this.selectedEmission = null;
      if (!this.order.emission_id) {
        return;
      }

      this.fetchEmissionDetail({ emission_id: this.order.emission_id, emission_location_id: this.order.emission_location_id }).then((content) => {
        this.reflectEmissionDetail(content)
      });
    },

    /**
     * 排出事業者/事業場情報の反映
     * @param emissionDetail { Object }
     */
    reflectEmissionDetail (emissionDetail) {
      /** 排出事業者の検索ダイアログで選択した値を反映 */

      this.selectedEmission = emissionDetail
      this.backupSelectedEmission = _.cloneDeep(emissionDetail)
      this.order.use_spot_emission_location = false;
      this.order.spot_input_completed = false;
      // this.order.emission_location_id = emissionDetail.location?.id || null;
      this.order.emission_location_code = emissionDetail.location?.code || null;

      if (emissionDetail.location?.id) {
        this.entryPatternForm.location_id = emissionDetail.location?.id || null;
        this.entryPatternForm.location_name = emissionDetail.location?.name || null;
      }

      /*
       * 排出事業情報の初期化
       */
      this.order.emission_location_name = null;
      this.order.emission_location_zip_code = null;
      this.order.emission_location_prefecture_code = null;
      this.order.emission_location_address_1 = null;
      this.order.emission_location_address_2 = null;
      this.order.emission_location_address_3 = null;
      this.order.emission_location_phone_number = null;

      this.searchEmissionDialogCancelCallback()
      this.reconfigureManifestType();
    },
    async saveCollection(move_to_transaction) {
      const params = this.buildParam(false)

      try {
        let content;

        if (this.editOrderId) {
          // 更新の場合
          content = await this.updateOrder({ id: this.editOrderId, params: params })

          if (this.loadBy === 'driver_schedule') {
            this.$emit('registerCallback');
            return;
          }

          if (move_to_transaction) {
            if (content.deal.status === 'final_closing' ) {
              this.$router.replace({ name: 'DriverSalesTransaction', params: { id: content.deal.id }}, () => {})
            } else {
              this.$router.replace({ name: 'DriverSalesTransactionEdit', params: { id: content.deal.id }}, () => {})
            }
          } else {
            await this.$router.push( { name: 'DriverOrderAccepts' } )
          }
        } else {
          // 新規作成の場合
          content = await this.createOrder({params: params})

          // ドライバースケジュールからの場合は、コールバックをキックして終了
          if (this.loadBy === 'driver_schedule') {
            this.$emit('registerCallback');
            return;
          }

          if (move_to_transaction) {
            if (content.deal.status === 'final_closing' ) {
              this.$router.replace({ name: 'DriverSalesTransaction', params: { id: content.deal.id }}, () => {})
            } else {
              this.$router.replace({ name: 'DriverSalesTransactionEdit', params: { id: content.deal.id }}, () => {})
            }
          } else {
            this.$router.push( { name: 'DriverOrderAccepts' } )
          }
        }
      } catch (error) {
        // API呼び出しでエラーが発生した場合
        console.error('Save collection error:', error)

        // エラーメッセージを表示
        if (error.response && error.response.data && error.response.data.message) {
          this.showError({ message: error.response.data.message })
        } else if (error.message) {
          this.showError({ message: error.message })
        } else {
          this.showError({ message: '保存中にエラーが発生しました。' })
        }
      } finally {
        // 成功・失敗に関わらずローディングを解除
        this.$emit('loadingCallback', false)
      }
    },
    /**
     * 送信パラメータの作成
     * ************************************************************
     * ここにパラメータを追加する場合は、登録パターンで利用している
     * mixins/driver/entry-pattern-builder-mixin.js
     * にも追加してください。
     * ************************************************************
     * @param draft
     * @return {FormData}
     */
    buildParam (draft) {

      const params = new FormData()
      params.append("orderable_type", this.$props.callableType);
      params.append('sales_staff', this.nullToBlank(this.order.sales_staff))
      params.append('dxe_vote_staff', this.nullToBlank(this.order.dxe_vote_staff))
      params.append('repeat_setting', this.nullToBlank(this.order.repeat_setting))
      params.append('selected_collected_dates', this.nullToBlank(this.order.selected_collected_dates))
      params.append('copy_count', this.nullToBlank(this.order.copy_count))

      params.append('driver_instruction', this.nullToBlank(this.order.driver_instruction))
      params.append('keyword', this.nullToBlank(this.order.keyword))

      params.append('plan_date', this.nullToBlank(this.order.collected_date))
      params.append('plan_start_time', this.nullToBlank(this.order.preferred_start_time))
      params.append('plan_end_time', this.nullToBlank(this.order.preferred_end_time))
      params.append('transport_user_id', this.nullToBlank(this.order.transport_user_id))
      params.append('transport_user_name', this.nullToBlank(this.order.transport_user_name))
      params.append('transportation_id', this.nullToBlank(this.order.transportation_id))
      params.append('vehicle_number', this.nullToBlank(this.order.vehicle_number))

      params.append('send_save', this.nullToBlank(this.sendSave))

      if (this.order.form_type === 'free_mode') {
        params.append('not_recorded_sales', true)

      } else {
        params.append('not_recorded_sales', this.nullToBlank(this.order.not_recorded_sales))
      }
      params.append('order_collection_attributes[id]', this.nullToBlank(this.order.order_collection_id))
      params.append('order_collection_attributes[use_spot_emission_location]', this.nullToBlank(this.order.use_spot_emission_location))

      if (this.order.form_type === 'master_mode') {
        params.append('order_collection_attributes[emission_id]', this.nullToBlank(this.order.emission_id))
        params.append('order_collection_attributes[emission_location_id]', this.nullToBlank(this.order.emission_location_id))


        if (this.order.use_spot_emission_location && this.order.spot_input_completed) {
          params.append('order_collection_attributes[emission_location_id]', this.nullToBlank(null))
          params.append('order_collection_attributes[emission_location_name]', this.nullToBlank(this.order.emission_location_name))
          params.append('order_collection_attributes[emission_location_zip_code]', this.nullToBlank(this.order.emission_location_zip_code))
          params.append('order_collection_attributes[emission_location_prefecture_code]', this.nullToBlank(this.order.emission_location_prefecture_code))
          params.append('order_collection_attributes[emission_location_address_1]', this.nullToBlank(this.order.emission_location_address_1))
          params.append('order_collection_attributes[emission_location_address_2]', this.nullToBlank(this.order.emission_location_address_2))
          params.append('order_collection_attributes[emission_location_address_3]', this.nullToBlank(this.order.emission_location_address_3))
          params.append('order_collection_attributes[emission_location_phone_number]', this.nullToBlank(this.order.emission_location_phone_number))
        }

      } else {
        params.append('order_collection_attributes[emission_name]', this.nullToBlank(this.order.emission_name))
        params.append('order_collection_attributes[emission_zip_code]', this.nullToBlank(this.order.emission_zip_code))
        params.append('order_collection_attributes[emission_prefecture_code]', this.nullToBlank(this.order.emission_prefecture_code))
        params.append('order_collection_attributes[emission_address_1]', this.nullToBlank(this.order.emission_address_1))
        params.append('order_collection_attributes[emission_address_2]', this.nullToBlank(this.order.emission_address_2))
        params.append('order_collection_attributes[emission_address_3]', this.nullToBlank(this.order.emission_address_3))
        params.append('order_collection_attributes[emission_phone_number]', this.nullToBlank(this.order.emission_phone_number))
        params.append('order_collection_attributes[emission_location_name]', this.nullToBlank(this.order.emission_location_name))
        params.append('order_collection_attributes[emission_location_zip_code]', this.nullToBlank(this.order.emission_location_zip_code))
        params.append('order_collection_attributes[emission_location_prefecture_code]', this.nullToBlank(this.order.emission_location_prefecture_code))
        params.append('order_collection_attributes[emission_location_address_1]', this.nullToBlank(this.order.emission_location_address_1))
        params.append('order_collection_attributes[emission_location_address_2]', this.nullToBlank(this.order.emission_location_address_2))
        params.append('order_collection_attributes[emission_location_address_3]', this.nullToBlank(this.order.emission_location_address_3))
        params.append('order_collection_attributes[emission_location_phone_number]', this.nullToBlank(this.order.emission_location_phone_number))

      }
      params.append('order_collection_attributes[form_type]', this.nullToBlank(this.order.form_type))
      params.append('order_collection_attributes[manifest_type]', this.nullToBlank(this.order.manifest_type))
      params.append('order_collection_attributes[deliver_staff]', this.nullToBlank(this.order.deliver_staff))
      params.append('order_collection_attributes[register_staff]', this.nullToBlank(this.order.register_staff))
      params.append('order_collection_attributes[past_manifest]', this.nullToBlank(this.order.past_manifest))

      /* 添付ファイル */
      for (const file of this.files) {
        // 新規 or 削除対象のみ
        if (!file.file && !file._destroy) continue

        if (file.id) {
          params.append('order_attachments_attributes[][id]', file.id)
        }
        params.append('order_attachments_attributes[][file]', file.file)
        if (file._destroy) {
          params.append('order_attachments_attributes[][_destroy]', file._destroy)
        }
      }
      let canceledManifestId = []
      /* 受注詳細 */
      this.order.manifests.forEach((manifest, index) => {

        if (manifest._destroy) {
          if (manifest.id) {
            canceledManifestId.push(manifest.id)
          }
          // manifest.id
        } else if (!manifest.already_registered) {
          /* ID */
          params.append(`manifests_attributes[${index}][id]`, this.nullToBlank(manifest.id))
          /* マニフェスト種別(マスタ or フリー) */
          params.append(`manifests_attributes[${index}][form_type]`, this.nullToBlank(this.order.form_type))
          /* 取引先売上品目ID */
          params.append(`manifests_attributes[${index}][sales_item_price_code]`, this.nullToBlank(manifest.sales_item_price_code))
          /* DXE起票担当者 */
          params.append(`manifests_attributes[${index}][dxe_vote_staff]`, this.nullToBlank(this.order.dxe_vote_staff))

          if (this.order.form_type === 'master_mode') {
            /* 排出事業者 */
            params.append(`manifests_attributes[${index}][supplierable_id]`, this.nullToBlank(this.nullToBlank(this.order.emission_id)))
            params.append(`manifests_attributes[${index}][supplierable_type]`, 'Emission')
            params.append(`manifests_attributes[${index}][supplierable_location_code]`, this.nullToBlank(this.nullToBlank(this.order.emission_location_code)))

            params.append(`manifests_attributes[${index}][use_spot_emission_location]`, this.nullToBlank(this.order.use_spot_emission_location))

            if (this.order.use_spot_emission_location && this.order.spot_input_completed) {
              params.append(`manifests_attributes[${index}][supplierable_location_code]`, this.nullToBlank(null))
              params.append(`manifests_attributes[${index}][emission_location_name]`, this.nullToBlank(this.order.emission_location_name))
              params.append(`manifests_attributes[${index}][emission_location_zip_code]`, this.nullToBlank(this.order.emission_location_zip_code))
              params.append(`manifests_attributes[${index}][emission_location_prefecture_code]`, this.nullToBlank(this.order.emission_location_prefecture_code))
              params.append(`manifests_attributes[${index}][emission_location_address_1]`, this.nullToBlank(this.order.emission_location_address_1))
              params.append(`manifests_attributes[${index}][emission_location_address_2]`, this.nullToBlank(this.order.emission_location_address_2))
              params.append(`manifests_attributes[${index}][emission_location_address_3]`, this.nullToBlank(this.order.emission_location_address_3))
              params.append(`manifests_attributes[${index}][emission_location_phone_number]`, this.nullToBlank(this.order.emission_location_phone_number))
            }

          } else {
            params.append(`manifests_attributes[${index}][emission_name]`, this.nullToBlank(this.order.emission_name))
            params.append(`manifests_attributes[${index}][emission_zip_code]`, this.nullToBlank(this.order.emission_zip_code))
            params.append(`manifests_attributes[${index}][emission_prefecture_code]`, this.nullToBlank(this.order.emission_prefecture_code))
            params.append(`manifests_attributes[${index}][emission_address_1]`, this.nullToBlank(this.order.emission_address_1))
            params.append(`manifests_attributes[${index}][emission_address_2]`, this.nullToBlank(this.order.emission_address_2))
            params.append(`manifests_attributes[${index}][emission_address_3]`, this.nullToBlank(this.order.emission_address_3))
            params.append(`manifests_attributes[${index}][emission_phone_number]`, this.nullToBlank(this.order.emission_phone_number))
            params.append(`manifests_attributes[${index}][emission_location_name]`, this.nullToBlank(this.order.emission_location_name))
            params.append(`manifests_attributes[${index}][emission_location_zip_code]`, this.nullToBlank(this.order.emission_location_zip_code))
            params.append(`manifests_attributes[${index}][emission_location_prefecture_code]`, this.nullToBlank(this.order.emission_location_prefecture_code))
            params.append(`manifests_attributes[${index}][emission_location_address_1]`, this.nullToBlank(this.order.emission_location_address_1))
            params.append(`manifests_attributes[${index}][emission_location_address_2]`, this.nullToBlank(this.order.emission_location_address_2))
            params.append(`manifests_attributes[${index}][emission_location_address_3]`, this.nullToBlank(this.order.emission_location_address_3))
            params.append(`manifests_attributes[${index}][emission_location_phone_number]`, this.nullToBlank(this.order.emission_location_phone_number))
          }
          /* 連絡番号1 */
          params.append(`manifests_attributes[${index}][contact_number_1]`, this.nullToBlank(manifest.contact_number_1))
          /* 連絡番号2 */
          params.append(`manifests_attributes[${index}][contact_number_2]`, this.nullToBlank(manifest.contact_number_2))
          /* 連絡番号3 */
          params.append(`manifests_attributes[${index}][contact_number_3]`, this.nullToBlank(manifest.contact_number_3))
          /* 引渡担当者 */
          params.append(`manifests_attributes[${index}][deliver_staff]`, this.nullToBlank(this.order.deliver_staff))
          /* 登録担当者 */
          params.append(`manifests_attributes[${index}][register_staff]`, this.nullToBlank(this.order.register_staff))
          /* 品目種別 */
          params.append(`manifests_attributes[${index}][item_type]`, this.callableType === 'general' ? 'GeneralItem' : 'Item')
          /* 取扱品目 */
          params.append(`manifests_attributes[${index}][item_id]`, this.nullToBlank(manifest.item_id))
          /* 廃棄物の名称 */
          params.append(`manifests_attributes[${index}][waste_name]`, this.nullToBlank(manifest.waste_name))
          /* マニフェスト番号 */
          if (this.order.manifest_type !== 'dxe_form' || manifest.includeNonSubscribeTrader || this.callableType === 'general') {
            params.append(`manifests_attributes[${index}][manifest_no]`, this.nullToBlank(manifest.manifest_no))
          }
          /* 荷姿の数量 */
          params.append(`manifests_attributes[${index}][packing_quantity]`, this.nullToBlank(manifest.packing_quantity))
          /* 荷姿 */
          params.append(`manifests_attributes[${index}][packing_id]`, this.nullToBlank(manifest.packing_id))
          /* 数量 */
          params.append(`manifests_attributes[${index}][quantity]`, this.nullToBlank(manifest.quantity))
          /* 数量単位 */
          params.append(`manifests_attributes[${index}][quantity_unit_id]`, this.nullToBlank(manifest.quantity_unit_id))
          /* 数量の確定者 */
          params.append(`manifests_attributes[${index}][quantity_confirm_id]`, this.nullToBlank(manifest.quantity_confirm_id))
          /* 有害物質1 */
          params.append(`manifests_attributes[${index}][hazardous_substance_1_id]`, this.nullToBlank(manifest.hazardous_substance_1_id))
          /* 有害物質2 */
          params.append(`manifests_attributes[${index}][hazardous_substance_2_id]`, this.nullToBlank(manifest.hazardous_substance_2_id))
          /* 有害物質3 */
          params.append(`manifests_attributes[${index}][hazardous_substance_3_id]`, this.nullToBlank(manifest.hazardous_substance_3_id))
          /* 有害物質4 */
          params.append(`manifests_attributes[${index}][hazardous_substance_4_id]`, this.nullToBlank(manifest.hazardous_substance_4_id))
          /* 有害物質5 */
          params.append(`manifests_attributes[${index}][hazardous_substance_5_id]`, this.nullToBlank(manifest.hazardous_substance_5_id))
          /* 有害物質6 */
          params.append(`manifests_attributes[${index}][hazardous_substance_6_id]`, this.nullToBlank(manifest.hazardous_substance_6_id))
          /* 運搬ルート */
          params.append(`manifests_attributes[${index}][transport_route_id]`, this.nullToBlank(manifest.transport_route_id))
          /* マニフェスト区分 */
          // params.append(`manifests_attributes[${index}][manifest_type]`, this.nullToBlank(manifest.manifest_type))
          params.append(`manifests_attributes[${index}][manifest_type]`, this.nullToBlank(this.order.manifest_type))
          /* 運搬方法 */
          params.append(`manifests_attributes[${index}][transportation_id]`, this.nullToBlank(this.order.transportation_id))
          /* 処分方法 */
          params.append(`manifests_attributes[${index}][disposal_method_id]`, this.nullToBlank(manifest.disposal_method_id))
          /* 基準重量 */
          params.append(`manifests_attributes[${index}][standard_quantity_type]`, this.nullToBlank(manifest.standard_quantity_type))
          /* 処分場処理方法 */          
          params.append(`manifests_attributes[${index}][recycle_disposer_disposal_method_id]`, this.nullToBlank(manifest.recycle_disposer_disposal_method_id))
          /* 過去マニフェストの起票 */
          params.append(`manifests_attributes[${index}][past_manifest]`, this.nullToBlank(this.order.past_manifest))
          /* 回収日 */
          params.append(`manifests_attributes[${index}][collected_date]`, this.nullToBlank(this.order.collected_date))
          /* 備考１ */
          params.append(`manifests_attributes[${index}][note_1]`, this.nullToBlank(manifest.note_1))
          /* 備考２ */
          params.append(`manifests_attributes[${index}][note_2]`, this.nullToBlank(manifest.note_2))
          /* 備考３ */
          params.append(`manifests_attributes[${index}][note_3]`, this.nullToBlank(manifest.note_3))
          /* 備考４ */
          params.append(`manifests_attributes[${index}][note_4]`, this.nullToBlank(manifest.note_4))
          /* 備考５ */
          params.append(`manifests_attributes[${index}][note_5]`, this.nullToBlank(manifest.note_5))
          /* 運搬担当者ID */
          params.append(`manifests_attributes[${index}][transport_user_id]`, this.nullToBlank(this.order.transport_user_id))
          /* 運搬担当者 */
          params.append(`manifests_attributes[${index}][transport_user_name]`, this.nullToBlank(this.order.transport_user_name))
          /* 車両番号 */
          params.append(`manifests_attributes[${index}][vehicle_number]`, this.nullToBlank(this.order.vehicle_number))

          /* マニフェスト検索キーワード */
          if (manifest.manifest_search_keywords) {
            params.append(`manifests_attributes[${index}][manifest_search_keywords_attributes][id]`, this.nullToBlank(manifest.manifest_search_keywords.id))
            params.append(`manifests_attributes[${index}][manifest_search_keywords_attributes][keyword]`, this.nullToBlank(manifest.manifest_search_keywords.keyword))
          }

          /* 下書き */
          params.append(`manifests_attributes[${index}][draft]`, draft)
        }
      })
      if (canceledManifestId.length > 0) {
        params.append('canceled_manifest_id', canceledManifestId.join(','))
      }
      return params
    },
    /**
     * 戻る処理
     */
    previousControl () {
      if (this.$route.query.d !== undefined) {
        this.$router.push( { name: 'DriverDashboard' } )
      } else {
        this.$router.push( { name: 'DriverOrderAccepts' } )
      }
    },

    /**
     * 日付選択ダイアログを開く
     */
    openDateSelectDialog() {
      this.dateSelectDialog = true
    },

    /**
     * 日付選択ダイアログを閉じる
     */
    closeDateSelectDialog() {
      this.dateSelectDialog = false
    },

    /**
     * 選択した日付を反映
     * @param {Array} sortedDates - 選択された日付の配列
     */
    applyDateSelectCallback(sortedDates) {
      if (sortedDates.length > 0) {
        // 最初の日付を回収日に設定
        this.order.collected_date = sortedDates[0]

        // すべての選択日付をorderに保存（Vue.setでリアクティブに更新）
        this.$set(this.order, 'selected_collected_dates', sortedDates)

        // 表示用の文字列を更新（/区切り）
        this.selected_collected_dates_display = sortedDates.join(' / ')
      } else {
        // 空の配列の場合は日付をクリア
        this.order.collected_date = null
        this.$set(this.order, 'selected_collected_dates', [])
        this.selected_collected_dates_display = ''
      }

      // ダイアログを閉じる
      this.closeDateSelectDialog()
    },


    /* メソッド -----> */

  }
}
</script>

<style scoped>

.text-small {
  font-size: .805rem !important;
}

.image-wrapper {
  border: 1px solid #ddd ;
  border-radius: 5px;
  display: inline-block;
  float: left;
  margin: 3px;
  padding: 0;
  .image {
    height: 150px;
    cursor: pointer;
    padding: 0;
    border: none;
  }
}
.radio-selected {
 background-color: #dfeffd !important;
}

</style>
